import React, { useState, useEffect, useMemo, useCallback } from "react";
import moment from "moment";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import { datearray } from "../Date";
import { handleErrorToast } from "../CustomFunctions";
import { ToastContainer } from "react-toastify";
import Loader from "../Loader";
import { Calender, ClockIcon, UserProfileIcon } from "../AllSvg";

// const Calaneder = () => {

//     const today = new Date();
//     const currentYear = today.getFullYear();
//     const currentMonth = (today.getMonth() + 1).toString().padStart(2, '0');

//     // State for available months/years
//     const [monthYearOptions, setMonthYearOptions] = useState([]);
//     const [selectedYear, setSelectedYear] = useState(currentYear.toString());
//     const [selectedMonth, setSelectedMonth] = useState(currentMonth);
//     const [selectedMonthYear, setSelectedMonthYear] = useState('');
//     const [timelineData, setTimelineData] = useState(null);
//     const [isLoading, setIsLoading] = useState(true);
//     const [buffer, setBuffer] = useState(true);
//     const [allJobappdatadatap, setAlljobappdata] = useState([]);

//     const getTimelineData = async () => {
//         setIsLoading(true);
//         try {
//             const emp_code = sessionStorage.getItem('emp_code');
//             const res = await axios.get(
//                 `${BASE_URL}/wfm/employee-latest-timeline/${emp_code}/`
//             );
//             setTimelineData(res.data);

//             generateMonthYearOptions(res.data);

//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     // Get employee timeline data on component mount
//     useEffect(() => {
//         getTimelineData();
//     }, []);

//     // Update this in your getTimelineData function after setting availableYears
//     const generateMonthYearOptions = (timelineData) => {
//         const options = [];
//         const joiningDate = new Date(timelineData.joining_date);
//         const joiningYear = joiningDate.getFullYear();
//         const joiningMonth = joiningDate.getMonth() + 1;

//         const latestAttendanceDate = timelineData.last_attendance_date
//             ? new Date(timelineData.last_attendance_date)
//             : new Date();
//         const latestAttendanceYear = latestAttendanceDate.getFullYear();
//         const latestAttendanceMonth = latestAttendanceDate.getMonth() + 1;

//         // Generate all months from joining date to latest attendance date
//         for (let year = joiningYear; year <= latestAttendanceYear; year++) {
//             let startMonth = 1;
//             let endMonth = 12;

//             if (year === joiningYear) {
//                 startMonth = joiningMonth;
//             }
//             if (year === latestAttendanceYear) {
//                 endMonth = latestAttendanceMonth;
//             }

//             for (let month = startMonth; month <= endMonth; month++) {
//                 options.push({
//                     value: `${year}-${month.toString().padStart(2, '0')}`,
//                     label: `${getMonthName(month)} ${year}`
//                 });
//             }
//         }

//         options.sort((a, b) => a.value.localeCompare(b.value));
//         setMonthYearOptions(options);

//         // Set initial selection to current month/year if available, otherwise most recent
//         const currentValue = `${currentYear}-${currentMonth}`;
//         const initialOption = options.find(opt => opt.value === currentValue) || options[options.length - 1];
//         if (initialOption) {
//             setSelectedMonthYear(initialOption.value);
//         }
//     };

//     const handleMonthYearChange = (e) => {
//         const value = e.target.value;
//         setSelectedMonthYear(value);

//         // Extract month and year from the selected value
//         const [year, month] = value.split('-');
//         setSelectedYear(year);
//         setSelectedMonth(month);
//     };

//     // Fetch attendance data when month/year changes
//     useEffect(() => {
//         if (selectedMonth && selectedYear) {
//             getJobapppdata(selectedMonth, selectedYear);
//         }
//     }, [selectedMonth, selectedYear]);



//     const getJobapppdata = async (month, year) => {
//         setBuffer(true);
//         try {
//             const emp_code = sessionStorage.getItem('emp_code');
//             const res = await axios.get(

//                 `${BASE_URL}/wfm/attendancefilterbyEmpByMonth/v2/${emp_code}/${month}/${year}/`
//                 // `${BASE_URL}/wfm/attendancefilterbyEmpByMonth/${emp_code}/${month}/${year}/`
//             );
//             const modifiedData = res.data.map(item => {
//                 const datee = item.date.split("-");
//                 const day = datee[2];
//                 return {
//                     ...item,
//                     date: day
//                 };
//             });
//             setAlljobappdata(modifiedData);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffer(false);
//         }
//     };

//     // Get month name helper
//     const getMonthName = (monthNumber) => {
//         const monthNames = [
//             "January", "February", "March", "April", "May", "June",
//             "July", "August", "September", "October", "November", "December"
//         ];
//         return monthNames[parseInt(monthNumber) - 1];
//     };

//     const state = {
//         dateContext: moment(`${selectedYear}-${selectedMonth}-01`, "YYYY-MM-DD"),
//         today: moment(),
//         selectedDay: null,
//     };

//     let weekdaysShort = moment.weekdaysShort();

//     let daysInMonth = () => {
//         return state.dateContext.daysInMonth();
//     };

//     const currentDay = () => {
//         if (selectedMonth === currentMonth && selectedYear === currentYear.toString()) {
//             return state.dateContext.format("D");
//         }
//         return null;
//     };

//     const firstDayOfMonth = () => {
//         let dateContext = state.dateContext;
//         let firstDay = moment(dateContext).startOf("month").format("d");
//         return firstDay;
//     };

//     let weekdayss = weekdaysShort.map((day) => {
//         return (
//             <td
//                 key={day}
//                 className="attendance-calander-heading font-weight500 font-size-heading attendance-calander-heading-td"
//             >
//                 <div className="attendance-calander-heading font-weight500 font-size-heading">{day}</div>
//             </td>
//         );
//     });

//     let blanks = [];
//     for (let i = 0; i < firstDayOfMonth(); i++) {
//         blanks.push(
//             <td key={i * 80} className="emptySlot">
//                 {""}
//             </td>
//         );
//     }

//     let daysInMonths = [];
//     const todayDate = today.getDate().toString().padStart(2, '0');

//     for (let d = 1; d <= daysInMonth(); d++) {
//         let className = d === currentDay() ? "day current-day" : "day";
//         let selectedClass = d === state.selectedDay ? " selected-day " : "";
//         let da = d < 10 ? "0" + d : "" + d;

//         daysInMonths.push(
//             <td
//                 key={d}
//                 className={className + selectedClass}
//                 style={{
//                     padding: "7px 5px",
//                     textAlign: "center",
//                 }}
//             >
//                 <span>
//                     <div className="flex-column-cal calander-height font-size-heading">
//                         <div>
//                             <span
//                                 className="attendance-calander-span font-weight500 font-size-heading"
//                                 style={{
//                                     background: (da === todayDate &&
//                                         selectedMonth === currentMonth &&
//                                         selectedYear === currentYear.toString())
//                                         ? "#2576BC" : "transparent",
//                                     color: (da === todayDate &&
//                                         selectedMonth === currentMonth &&
//                                         selectedYear === currentYear.toString())
//                                         ? "white" : "",
//                                     width: "35px",
//                                     height: "35px",
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "center",
//                                     borderRadius: "50%",
//                                     padding: "2px",
//                                 }}
//                             >
//                                 {String(d).padStart(2, "0")}
//                             </span>
//                         </div>

//                         <>
//                             {allJobappdatadatap.map((data) => {
//                                 const inTime = data ? data.in_time : "-";
//                                 const outTime = data ? data.out_time : "-";
//                                 const attstat = data ? data.attendence_status : "-";
//                                 const duration = data ? data.work_duration : "-";
//                                 let day_status = data ? data.day_status : "-";

//                                 const day_status_full = data
//                                     ? data.day_status === "ontime"
//                                         ? "Present"
//                                         : data.day_status === "outduty"
//                                             ? "Out Duty"
//                                             : data.day_status === "halfday"
//                                                 ? "Half Day"
//                                                 : data.day_status === "paidleave"
//                                                     ? "Paid Leave"
//                                                     : data.day_status === "late"
//                                                         ? "Late"
//                                                         : data.day_status === "weeklyoff"
//                                                             ? "Weekly Off"
//                                                             : data.day_status === "wop"
//                                                                 ? "Weekly Off Present"
//                                                                 : data.day_status === "rlm"
//                                                                     ? "Rectified Late Mark"
//                                                                     : data.day_status === "halfdayleave"
//                                                                         ? "Half Day Leave"
//                                                                         : data.day_status === "paidhalfdayleave"
//                                                                             ? "Paid Half Day Leave"
//                                                                             : data.day_status === "unpaidleave"
//                                                                                 ? "Unpaid Leave"
//                                                                                 : data.day_status === "shortleave"
//                                                                                     ? "Short Leave"
//                                                                                     : data.day_status === "unpaidshortleave"
//                                                                                         ? "Unpaid Short Leave"
//                                                                                         : data.day_status === "unpaidleavehd"
//                                                                                             ? "Unpaid Half Day Leave"
//                                                                                             : data.day_status === "hdoutduty"
//                                                                                                 ? "Half Day Out Duty"
//                                                                                                 : data.day_status === "shortoutduty"
//                                                                                                     ? "Short Out Duty"
//                                                                                                     : data.day_status === "misspunch"
//                                                                                                         ? "Missed Punch"
//                                                                                                         : data.day_status === "holiday"
//                                                                                                             ? "Holiday"
//                                                                                                             : data.day_status === "absent"
//                                                                                                                 ? "Absent"
//                                                                                                                 : data.day_status.slice(0, 2)
//                                     : "-";

//                                 const day_status_short = data
//                                     ? data.day_status === "ontime"
//                                         ? <span style={{ fontSize: 'small' }}>Present</span>
//                                         : data.day_status === "outduty"
//                                             ? <span style={{ fontSize: 'small' }}>OutDuty</span>
//                                             : data.day_status === "halfday"
//                                                 ? <span style={{ fontSize: 'small' }}>Half Day</span>
//                                                 : data.day_status === "paidleave"
//                                                     ? <span style={{ fontSize: 'small' }}>PaidLeave</span>
//                                                     : data.day_status === "late"
//                                                         ? <span style={{ fontSize: 'small' }}>Late</span>
//                                                         : data.day_status === "weeklyoff"
//                                                             ? <span style={{ fontSize: 'small' }}>WeeklyOff</span>
//                                                             : data.day_status === "wop"
//                                                                 ? <span style={{ fontSize: 'small' }}>WOP</span>
//                                                                 : data.day_status === "rlm"
//                                                                     ? <span style={{ fontSize: 'small' }}>RLM</span>
//                                                                     : data.day_status === "halfdayleave"
//                                                                         ? <span style={{ fontSize: 'small' }}>Half Day L</span>
//                                                                         : data.day_status === "paidhalfdayleave"
//                                                                             ? <span style={{ fontSize: 'small' }}>Paid HDL</span>
//                                                                             : data.day_status === "unpaidleave"
//                                                                                 ? <span style={{ fontSize: 'small' }}>Unpaid Leave</span>
//                                                                                 : data.day_status === "shortleave"
//                                                                                     ? <span style={{ fontSize: 'small' }}>SL</span>
//                                                                                     : data.day_status === "unpaidshortleave"
//                                                                                         ? <span style={{ fontSize: 'small' }}>Unpaid SL</span>
//                                                                                         : data.day_status === "unpaidleavehd"
//                                                                                             ? <span style={{ fontSize: 'small' }}>Unpaid HDL</span>
//                                                                                             : data.day_status === "hdoutduty"
//                                                                                                 ? <span style={{ fontSize: 'small' }}>Half OD</span>
//                                                                                                 : data.day_status === "shortoutduty"
//                                                                                                     ? <span style={{ fontSize: 'small' }}>ShortOD</span>
//                                                                                                     : data.day_status === "misspunch"
//                                                                                                         ? <span style={{ fontSize: 'small' }}>Mispunch</span>
//                                                                                                         : data.day_status === "holiday"
//                                                                                                             ? <span style={{ fontSize: 'small' }}>Holiday</span>
//                                                                                                             : data.day_status === "absent"
//                                                                                                                 ? <span style={{ fontSize: 'small' }}>Absent</span>
//                                                                                                                 : <span style={{ fontSize: 'small' }}>{data.day_status.slice(0, 2)}</span>
//                                     : <span style={{ fontSize: 'small' }}>-</span>;

//                                 return (
//                                     <>
//                                         {data.date === da ? (
//                                             <span
//                                                 data-status={data.day_status}
//                                                 className="attendance-status font-weight500 font-size-label"
//                                                 style={{ cursor: "pointer" }}
//                                             >
//                                                 <span
//                                                     className="progress-profile-percent"
//                                                     title={`In Time: ${inTime}\nOut Time: ${outTime}\nAttendance Status: ${attstat}\nDay Status: ${day_status_full}\nDuration: ${duration} hrs`}
//                                                 >
//                                                     {day_status_short}
//                                                 </span>
//                                             </span>
//                                         ) : (
//                                             ""
//                                         )}
//                                     </>
//                                 );
//                             })}
//                         </>
//                     </div>
//                 </span>
//             </td>
//         );
//     }

//     var totalSlots = [...blanks, ...daysInMonths];
//     let rows = [];
//     let cells = [];

//     totalSlots.forEach((row, i) => {
//         if (i % 7 !== 0) {
//             cells.push(row);
//         } else {
//             let insertRow = cells.slice();
//             rows.push(insertRow);
//             cells = [];
//             cells.push(row);
//         }
//         if (i === totalSlots.length - 1) {
//             let insertRow = cells.slice();
//             rows.push(insertRow);
//         }
//     });

//     let trElems = rows.map((d, i) => {
//         return <tr key={i * 100}>{d}</tr>;
//     });

//     return (
//         <>
//             <div className="attendance-calendar-container">
//                 <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }} className="bgwhite">
//                     <div className="employee-detail-edit-svg font-weight600 font-size-heading">
//                         {getMonthName(selectedMonth)} {selectedYear}
//                     </div>
//                     <div className="radialchart-dropdown">
//                         {isLoading ? (
//                             <div className="spinner-small"></div>
//                         ) : (
//                             <select
//                                 style={{ border: "none", minWidth: "150px" }}
//                                 onChange={handleMonthYearChange}
//                                 value={selectedMonthYear}
//                                 className="month-year-select"
//                             >
//                                 {monthYearOptions.map(option => (
//                                     <option key={option.value} value={option.value}>
//                                         {option.label}
//                                     </option>
//                                 ))}
//                             </select>
//                         )}
//                     </div>
//                 </div>
//                 <table className="calendar">
//                     {buffer ?
//                         <Loader container={true} />
//                         :
//                         <tbody className="width-50vw">
//                             <tr>{weekdayss}</tr>
//                             {trElems}
//                         </tbody>
//                     }
//                 </table>
//             </div>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//         </>
//     );
// };

// export default Calaneder




// ─── Status lookup tables (replaces nested ternaries) ────────────────────────



// const DAY_STATUS_FULL = {
//     ontime: "Present",
//     outduty: "Out Duty",
//     halfday: "Half Day",
//     paidleave: "Paid Leave",
//     late: "Late",
//     weeklyoff: "Weekly Off",
//     wop: "Weekly Off Present",
//     rlm: "Rectified Late Mark",
//     halfdayleave: "Half Day Leave",
//     paidhalfdayleave: "Paid Half Day Leave",
//     unpaidleave: "Unpaid Leave",
//     shortleave: "Short Leave",
//     unpaidshortleave: "Unpaid Short Leave",
//     unpaidleavehd: "Unpaid Half Day Leave",
//     hdoutduty: "Half Day Out Duty",
//     shortoutduty: "Short Out Duty",
//     misspunch: "Missed Punch",
//     holiday: "Holiday",
//     absent: "Absent",
// };

// const DAY_STATUS_SHORT = {
//     ontime: "Present",
//     outduty: "OutDuty",
//     halfday: "Half Day",
//     paidleave: "PaidLeave",
//     late: "Late",
//     weeklyoff: "WeeklyOff",
//     wop: "WOP",
//     rlm: "RLM",
//     halfdayleave: "Half Day L",
//     paidhalfdayleave: "Paid HDL",
//     unpaidleave: "Unpaid Leave",
//     shortleave: "SL",
//     unpaidshortleave: "Unpaid SL",
//     unpaidleavehd: "Unpaid HDL",
//     hdoutduty: "Half OD",
//     shortoutduty: "ShortOD",
//     misspunch: "Mispunch",
//     holiday: "Holiday",
//     absent: "Absent",
// };

// const getMonthName = (monthNumber) => {
//     const monthNames = [
//         "January", "February", "March", "April", "May", "June",
//         "July", "August", "September", "October", "November", "December",
//     ];
//     return monthNames[parseInt(monthNumber) - 1];
// };
// // ─────────────────────────────────────────────────────────────────────────────

// const Calaneder = () => {
//     const today = new Date();
//     const currentYear = today.getFullYear();
//     const currentMonth = (today.getMonth() + 1).toString().padStart(2, "0");

//     const [monthYearOptions, setMonthYearOptions] = useState([]);
//     const [selectedYear, setSelectedYear] = useState(currentYear.toString());
//     const [selectedMonth, setSelectedMonth] = useState(currentMonth);
//     const [selectedMonthYear, setSelectedMonthYear] = useState("");
//     const [timelineData, setTimelineData] = useState(null);
//     const [isLoading, setIsLoading] = useState(true);
//     const [buffer, setBuffer] = useState(true);

//     // ── NEW: stores the attendance array from v2 response ──────────────────────
//     const [attendanceList, setAttendanceList] = useState([]);
//     // Optional: store payroll range if needed for future UI
//     const [payrollRange, setPayrollRange] = useState({ start: null, end: null });

//     // ── Build a Map for O(1) day-lookup instead of .map() per cell ─────────────
//     // key: "DD" (zero-padded day), value: attendance record
//     // const attendanceByDay = useMemo(() => {
//     //     const map = new Map();
//     //     attendanceList.forEach((item) => {
//     //         map.set(item.date, item); // item.date is already "DD" after transform
//     //     });
//     //     return map;
//     // }, [attendanceList]);
//     //  Map by full date "YYYY-MM-DD" instead of just "DD"
//     const attendanceByDay = useMemo(() => {
//         const map = new Map();
//         attendanceList.forEach((item) => {
//             map.set(item.date, item);  // key = "2026-02-25"
//         });
//         return map;
//     }, [attendanceList]);



//     // ── Timeline fetch ─────────────────────────────────────────────────────────
//     const getTimelineData = async () => {
//         setIsLoading(true);
//         try {
//             const emp_code = sessionStorage.getItem("emp_code");
//             const res = await axios.get(`${BASE_URL}/wfm/employee-latest-timeline/${emp_code}/`);
//             setTimelineData(res.data);
//             generateMonthYearOptions(res.data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     useEffect(() => {
//         getTimelineData();
//     }, []);

//     const generateMonthYearOptions = (data) => {
//         const options = [];
//         const joining = new Date(data.joining_date);
//         const joiningY = joining.getFullYear();
//         const joiningM = joining.getMonth() + 1;

//         const latest = data.last_attendance_date ? new Date(data.last_attendance_date) : new Date();
//         const latestY = latest.getFullYear();
//         const latestM = latest.getMonth() + 1;

//         for (let y = joiningY; y <= latestY; y++) {
//             const startM = y === joiningY ? joiningM : 1;
//             const endM = y === latestY ? latestM : 12;
//             for (let m = startM; m <= endM; m++) {
//                 options.push({
//                     value: `${y}-${m.toString().padStart(2, "0")}`,
//                     label: `${getMonthName(m)} ${y}`,
//                 });
//             }
//         }

//         options.sort((a, b) => a.value.localeCompare(b.value));
//         setMonthYearOptions(options);

//         const currentValue = `${currentYear}-${currentMonth}`;
//         const initialOption = options.find((o) => o.value === currentValue) || options[options.length - 1];
//         if (initialOption) setSelectedMonthYear(initialOption.value);
//     };

//     const handleMonthYearChange = (e) => {
//         const value = e.target.value;
//         setSelectedMonthYear(value);
//         const [year, month] = value.split("-");
//         setSelectedYear(year);
//         setSelectedMonth(month);
//     };

//     useEffect(() => {
//         if (selectedMonth && selectedYear) {
//             getAttendanceData(selectedMonth, selectedYear);
//         }
//     }, [selectedMonth, selectedYear]);

//     // ── CHANGED: parse v2 response shape { data: [...], payroll_start_date, payroll_end_date } ──
//     const getAttendanceData = async (month, year) => {
//         setBuffer(true);
//         try {
//             const emp_code = sessionStorage.getItem("emp_code");
//             const res = await axios.get(
//                 `${BASE_URL}/wfm/attendancefilterbyEmpByMonth/v2/${emp_code}/${month}/${year}/`

//             );

//             // ── KEY CHANGE: attendance records now live in res.data.data ────────────
//             const records = res.data.data ?? [];

//             // Store payroll range (available for future use)
//             setPayrollRange({
//                 start: res.data.payroll_start_date,
//                 end: res.data.payroll_end_date,
//             });

//             // Transform: keep only the "DD" day portion of the date string
//             // const transformed = records.map((item) => ({
//             //     ...item,
//             //     date: item.date.split("-")[2], // "2026-01-23" → "23"
//             // }));

//             setAttendanceList(records);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffer(false);
//         }
//     };

//     // ── Calendar helpers ───────────────────────────────────────────────────────
//     const dateContext = moment(`${selectedYear}-${selectedMonth}-01`, "YYYY-MM-DD");
//     //  const daysInMonth = dateContext.daysInMonth();
//     // ── CHANGED: respect payroll window instead of always 1→daysInMonth ────────
//     const payrollStart = payrollRange.start ? parseInt(payrollRange.start.split("-")[2], 10) : 1;
//     const payrollEnd = payrollRange.end ? parseInt(payrollRange.end.split("-")[2], 10) : dateContext.daysInMonth();
//     // Blank cells = day-of-week offset of the FIRST payroll day (not always the 1st)
//     const firstPayrollDayOfWeek = parseInt(
//         moment(`${selectedYear}-${selectedMonth}-${String(payrollStart).padStart(2, "0")}`, "YYYY-MM-DD").format("d"),
//         10
//     );

//     //  const firstDayOfMonth = parseInt(moment(dateContext).startOf("month").format("d"), 10);
//     const isCurrentMonthYear =
//         selectedMonth === currentMonth && selectedYear === currentYear.toString();
//     const todayDate = today.getDate().toString().padStart(2, "0");

//     const weekdayss = moment.weekdaysShort().map((day) => (
//         <td key={day} className="attendance-calander-heading font-weight500 font-size-heading attendance-calander-heading-td">
//             <div className="attendance-calander-heading font-weight500 font-size-heading">{day}</div>
//         </td>
//     ));

//     const startDate = payrollRange.start
//         ? moment(payrollRange.start, "YYYY-MM-DD")
//         : moment(`${selectedYear}-${selectedMonth}-01`, "YYYY-MM-DD");

//     const endDate = payrollRange.end
//         ? moment(payrollRange.end, "YYYY-MM-DD")
//         : moment(`${selectedYear}-${selectedMonth}-01`, "YYYY-MM-DD").endOf("month");

//     const totalDays = endDate.diff(startDate, "days") + 1;  // 28 days for Feb25-Mar24

//     const firstDayOfWeek = parseInt(startDate.format("d"), 10);  // day of week of Feb 25

//     const blanks = Array.from({ length: firstDayOfWeek }, (_, i) => (
//         <td key={`blank-${i}`} className="emptySlot">{""}</td>
//     ));

//     // Blank cells before the 1st
//     // const blanks = Array.from({ length: firstPayrollDayOfWeek }, (_, i) => (
//     //     <td key={`blank-${i}`} className="emptySlot">{""}</td>
//     // ));
//     // Day cells
//     const daysInMonths = Array.from({ length: totalDays }, (_, idx) => {
//         const currentDate = startDate.clone().add(idx, "days");
//         const fullDate = currentDate.format("YYYY-MM-DD");  // "2026-02-25"
//         const da = currentDate.format("DD");                // "25"
//         const monthLabel = currentDate.format("MMM");       // "Feb" / "Mar"

//         const isToday = fullDate === moment().format("YYYY-MM-DD");

//         const record = attendanceByDay.get(fullDate);  // ✅ lookup by full date
//         const fullStatus = record ? (DAY_STATUS_FULL[record.day_status] ?? record.day_status) : "-";
//         const shortStatus = record ? (DAY_STATUS_SHORT[record.day_status] ?? record.day_status) : "-";

//         //  Show month label when date is from different month
//         const isStartMonth = currentDate.month() === startDate.month();
//         const showMonthLabel = !isStartMonth && currentDate.date() === 1;  // show at month boundary

//         // const daysInMonths = Array.from({ length: payrollEnd - payrollStart + 1 }, (_, idx) => {
//         //     const d = payrollStart + idx;
//         //     const da = d.toString().padStart(2, "0");
//         //     const isToday = da === todayDate && isCurrentMonthYear;

//         //     const record = attendanceByDay.get(da);
//         //     const fullStatus = record ? (DAY_STATUS_FULL[record.day_status] ?? record.day_status.slice(0, 2)) : "-";
//         //     const shortStatus = record ? (DAY_STATUS_SHORT[record.day_status] ?? record.day_status.slice(0, 2)) : "-";


//         return (
//             <td
//                 key={fullDate}
//                 className={"day"}
//                 style={{ padding: "7px 5px", textAlign: "center" }}
//             >
//                 <span>
//                     <div className="flex-column-cal calander-height font-size-heading">
//                         {/* Date number */}
//                         <div>
//                             <span
//                                 className="attendance-calander-span font-weight500 font-size-heading"
//                                 style={{
//                                     background: isToday ? "#2576BC" : "transparent",
//                                     color: isToday ? "white" : "",
//                                     width: "35px",
//                                     height: "35px",
//                                     display: "flex",
//                                     alignItems: "center",
//                                     justifyContent: "center",
//                                     borderRadius: "50%",
//                                     padding: "2px",
//                                 }}
//                             >
//                                 {da}
//                                 {showMonthLabel && (
//                                     <span style={{ fontSize: "9px", display: "block", lineHeight: 1 }}>
//                                         {monthLabel}
//                                     </span>
//                                 )}
//                             </span>
//                         </div>

//                         {/* Attendance status badge */}
//                         {record && (
//                             <span
//                                 data-status={record.day_status}
//                                 className="attendance-status font-weight500 font-size-label"
//                                 style={{ cursor: "pointer" }}
//                             >
//                                 <span
//                                     className="progress-profile-percent"
//                                     title={
//                                         `In Time: ${record.in_time}\n` +
//                                         `Out Time: ${record.out_time}\n` +
//                                         `Attendance Status: ${record.attendence_status}\n` +
//                                         `Day Status: ${fullStatus}\n` +
//                                         `Duration: ${record.work_duration} hrs`
//                                     }
//                                 >
//                                     <span style={{ fontSize: "small" }}>{shortStatus}</span>
//                                 </span>
//                             </span>
//                         )}
//                     </div>
//                 </span>
//             </td>
//         );
//     });

//     // Build table rows (7 cells per row)
//     const totalSlots = [...blanks, ...daysInMonths];
//     const rows = [];
//     for (let i = 0; i < totalSlots.length; i += 7) {
//         rows.push(<tr key={i}>{totalSlots.slice(i, i + 7)}</tr>);
//     }


//     const getPayrollMonthLabel = (startDate, endDate) => {
//         if (!startDate || !endDate) return `${getMonthName(selectedMonth)} ${selectedYear}`;

//         const start = new Date(startDate);
//         const end = new Date(endDate);

//         const startMonthName = start.toLocaleString("default", { month: "long" });
//         const endMonthName = end.toLocaleString("default", { month: "long" });
//         const endYear = end.getFullYear();

//         if (startMonthName === endMonthName) {
//             return `${endMonthName} ${endYear}`;
//         }

//         return `${startMonthName} - ${endMonthName} ${endYear}`;
//     };

//     return (
//         <>
//             <div className="attendance-calendar-container">
//                 <div
//                     style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}
//                     className="bgwhite"
//                 >
//                     <div className="employee-detail-edit-svg font-weight600 font-size-heading">
//                         {/* {getMonthName(selectedMonth)} {selectedYear} */}
//                         {getPayrollMonthLabel(payrollRange.start, payrollRange.end)}
//                     </div>
//                     <div className="radialchart-dropdown">
//                         {isLoading ? (
//                             <div className="spinner-small"></div>
//                         ) : (
//                             <select
//                                 style={{ border: "none", minWidth: "150px" }}
//                                 onChange={handleMonthYearChange}
//                                 value={selectedMonthYear}
//                                 className="month-year-select"
//                             >
//                                 {monthYearOptions.map((option) => (
//                                     <option key={option.value} value={option.value}>
//                                         {option.label}
//                                     </option>
//                                 ))}
//                             </select>
//                         )}
//                     </div>
//                 </div>

//                 <table className="calendar">
//                     {buffer ? (
//                         <Loader container={true} />
//                     ) : (
//                         <tbody className="width-50vw">
//                             <tr>{weekdayss}</tr>
//                             {rows}
//                         </tbody>
//                     )}
//                 </table>
//             </div>

//             <ToastContainer
//                 position="top-center"
//                 autoClose={1000}
//                 hideProgressBar={false}
//                 newestOnTop={true}
//                 closeOnClick
//                 rtl={false}
//                 pauseOnFocusLoss
//                 draggable
//                 pauseOnHover
//             />
//         </>
//     );
// };

// export default Calaneder;




// -----------------------display dual month calender 



// ─── Dual-Month Payroll Calendar ─────────────────────────────────────────────
// Both months render ALL their days (no clipping).
// Active window = payroll_start_date → payroll_end_date from CURR month API only.
// Prev month  : dates < payrollStart  → disabled  (striped, faded, tooltip still works)
// Curr month  : dates > payrollEnd    → disabled
// Disabled cells show full attendance data + tooltip — user can still see everything.
// ─────────────────────────────────────────────────────────────────────────────

// ─── Dual-Month Payroll Calendar ─────────────────────────────────────────────
// Both months render ALL their days (no clipping).
// Active window = payroll_start_date → payroll_end_date from CURR month API only.
// Prev month  : dates < payrollStart  → disabled  (striped, faded, tooltip still works)
// Curr month  : dates > payrollEnd    → disabled
// Disabled cells show full attendance data + tooltip — user can still see everything.
// ─────────────────────────────────────────────────────────────────────────────

// const DAY_STATUS_FULL = {
//     ontime: "Present", outduty: "Out Duty", halfday: "Half Day",
//     paidleave: "Paid Leave", late: "Late", weeklyoff: "Weekly Off",
//     wop: "Weekly Off Present", rlm: "Rectified Late Mark",
//     halfdayleave: "Half Day Leave", paidhalfdayleave: "Paid Half Day Leave",
//     unpaidleave: "Unpaid Leave", shortleave: "Short Leave",
//     unpaidshortleave: "Unpaid Short Leave", unpaidleavehd: "Unpaid Half Day Leave",
//     hdoutduty: "Half Day Out Duty", shortoutduty: "Short Out Duty",
//     misspunch: "Missed Punch", holiday: "Holiday", absent: "Absent",
// };

// const DAY_STATUS_SHORT = {
//     ontime: "Present", outduty: "OutDuty", halfday: "Half Day",
//     paidleave: "PaidLeave", late: "Late", weeklyoff: "WeeklyOff",
//     wop: "WOP", rlm: "RLM", halfdayleave: "Half Day L",
//     paidhalfdayleave: "Paid HDL", unpaidleave: "Unpaid Leave",
//     shortleave: "SL", unpaidshortleave: "Unpaid SL",
//     unpaidleavehd: "Unpaid HDL", hdoutduty: "Half OD",
//     shortoutduty: "ShortOD", misspunch: "Mispunch",
//     holiday: "Holiday", absent: "Absent",
// };

// // Exact same colour tokens as your existing data-status CSS
// const STATUS_COLORS = {
//     ontime: { bg: "#B5D4F4", color: "#0C447C" },
//     late: { bg: "#FAC775", color: "#633806" },
//     rlm: { bg: "#FAC775", color: "#633806" },
//     halfday: { bg: "#F4C0D1", color: "#72243E" },
//     halfdayleave: { bg: "#F4C0D1", color: "#72243E" },
//     paidhalfdayleave: { bg: "#F4C0D1", color: "#72243E" },
//     paidleave: { bg: "#CECBF6", color: "#3C3489" },
//     weeklyoff: { bg: "#D3D1C7", color: "#444441" },
//     wop: { bg: "#C0DD97", color: "#27500A" },
//     absent: { bg: "#F7C1C1", color: "#791F1F" },
//     holiday: { bg: "#CECBF6", color: "#3C3489" },
//     unpaidleave: { bg: "#F5C4B3", color: "#712B13" },
//     unpaidshortleave: { bg: "#F5C4B3", color: "#712B13" },
//     unpaidleavehd: { bg: "#F5C4B3", color: "#712B13" },
//     shortleave: { bg: "#9FE1CB", color: "#085041" },
//     outduty: { bg: "#9FE1CB", color: "#085041" },
//     hdoutduty: { bg: "#9FE1CB", color: "#085041" },
//     shortoutduty: { bg: "#9FE1CB", color: "#085041" },
//     misspunch: { bg: "#FAC775", color: "#633806" },
// };

// const getMonthName = (monthNumber) => {
//     const names = [
//         "January", "February", "March", "April", "May", "June",
//         "July", "August", "September", "October", "November", "December",
//     ];
//     return names[parseInt(monthNumber) - 1];
// };

// // ─────────────────────────────────────────────────────────────────────────────

// const Calaneder = () => {
//     const today = new Date();
//     const currentYear = today.getFullYear();
//     const currentMonth = (today.getMonth() + 1).toString().padStart(2, "0");

//     const [monthYearOptions, setMonthYearOptions] = useState([]);
//     const [selectedYear, setSelectedYear] = useState(currentYear.toString());
//     const [selectedMonth, setSelectedMonth] = useState(currentMonth);
//     const [selectedMonthYear, setSelectedMonthYear] = useState("");
//     const [isLoading, setIsLoading] = useState(true);

//     // Separate lists for each month block
//     const [currAttendanceList, setCurrAttendanceList] = useState([]);
//     const [prevAttendanceList, setPrevAttendanceList] = useState([]);

//     // Payroll window — comes ONLY from curr month API, never overwritten by prev API
//     const [payrollRange, setPayrollRange] = useState({ start: null, end: null });

//     const [currBuffer, setCurrBuffer] = useState(true);
//     const [prevBuffer, setPrevBuffer] = useState(true);

//     // ── O(1) lookup maps ───────────────────────────────────────────────────────
//     const currAttendanceMap = useMemo(() => {
//         const m = new Map();
//         currAttendanceList.forEach((item) => m.set(item.date, item));
//         return m;
//     }, [currAttendanceList]);

//     const prevAttendanceMap = useMemo(() => {
//         const m = new Map();
//         prevAttendanceList.forEach((item) => m.set(item.date, item));
//         return m;
//     }, [prevAttendanceList]);

//     // ── Derived prev-month values ──────────────────────────────────────────────
//     const prevMonthNum = selectedMonth === "01" ? 12 : parseInt(selectedMonth) - 1;
//     const prevYear = selectedMonth === "01"
//         ? (parseInt(selectedYear) - 1).toString()
//         : selectedYear;
//     const prevMonthStr = prevMonthNum.toString().padStart(2, "0");

//     // ── payrollStartDay / payrollEndDay ────────────────────────────────────────
//     // payrollRange.start = "2026-05-25" → startDay = 25  (first active day in prev month)
//     // payrollRange.end   = "2026-06-24" → endDay   = 24  (last  active day in curr month)
//     const payrollStartDay = payrollRange.start
//         ? parseInt(payrollRange.start.split("-")[2], 10) : 25;
//     const payrollEndDay = payrollRange.end
//         ? parseInt(payrollRange.end.split("-")[2], 10) : 24;

//     // ── isActiveDate: is this full "YYYY-MM-DD" inside the payroll window? ─────
//     // NOTE: we compare full ISO strings so cross-month logic is always correct.
//     const isActiveDate = useCallback((fullDate) => {
//         if (!payrollRange.start || !payrollRange.end) return true;
//         return fullDate >= payrollRange.start && fullDate <= payrollRange.end;
//     }, [payrollRange]);

//     // ── Timeline fetch ─────────────────────────────────────────────────────────
//     useEffect(() => {
//         const getTimelineData = async () => {
//             setIsLoading(true);
//             try {
//                 const emp_code = sessionStorage.getItem("emp_code");
//                 const res = await axios.get(
//                     `${BASE_URL}/wfm/employee-latest-timeline/${emp_code}/`
//                 );
//                 generateMonthYearOptions(res.data);
//             } catch (err) {
//                 handleErrorToast(err);
//             } finally {
//                 setIsLoading(false);
//             }
//         };
//         getTimelineData();
//     }, []); // eslint-disable-line react-hooks/exhaustive-deps

//     const generateMonthYearOptions = (data) => {
//         const options = [];
//         const joining = new Date(data.joining_date);
//         const joiningY = joining.getFullYear();
//         const joiningM = joining.getMonth() + 1;
//         const latest = data.last_attendance_date
//             ? new Date(data.last_attendance_date) : new Date();
//         const latestY = latest.getFullYear();
//         const latestM = latest.getMonth() + 1;

//         for (let y = joiningY; y <= latestY; y++) {
//             const startM = y === joiningY ? joiningM : 1;
//             const endM = y === latestY ? latestM : 12;
//             for (let m = startM; m <= endM; m++) {
//                 options.push({
//                     value: `${y}-${m.toString().padStart(2, "0")}`,
//                     label: `${getMonthName(m)} ${y}`,
//                 });
//             }
//         }
//         options.sort((a, b) => a.value.localeCompare(b.value));
//         setMonthYearOptions(options);

//         const currentValue = `${currentYear}-${currentMonth}`;
//         const initialOption =
//             options.find((o) => o.value === currentValue) || options[options.length - 1];
//         if (initialOption) setSelectedMonthYear(initialOption.value);
//     };

//     const handleMonthYearChange = (e) => {
//         const [year, month] = e.target.value.split("-");
//         setSelectedMonthYear(e.target.value);
//         setSelectedYear(year);
//         setSelectedMonth(month);
//     };

//     // ── Fetch both months whenever selection changes ───────────────────────────
//     useEffect(() => {
//         if (selectedMonth && selectedYear) {
//             fetchAttendance(selectedMonth, selectedYear, "curr");
//             fetchAttendance(prevMonthStr, prevYear, "prev");
//         }
//     }, [selectedMonth, selectedYear]); // eslint-disable-line react-hooks/exhaustive-deps

//     const fetchAttendance = async (month, year, which) => {
//         which === "curr" ? setCurrBuffer(true) : setPrevBuffer(true);
//         try {
//             const emp_code = sessionStorage.getItem("emp_code");
//             const res = await axios.get(
//                 `${BASE_URL}/wfm/attendancefilterbyEmpByMonth/v2/${emp_code}/${month}/${year}/`
//             );
//             const records = res.data.data ?? [];

//             if (which === "curr") {
//                 // ── payroll window from curr API only ──────────────────────────
//                 setPayrollRange({
//                     start: res.data.payroll_start_date,  // "2026-05-25"
//                     end: res.data.payroll_end_date,    // "2026-06-24"
//                 });
//                 setCurrAttendanceList(records);
//             } else {
//                 // prev month: store records only — do NOT touch payrollRange
//                 setPrevAttendanceList(records);
//             }
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             which === "curr" ? setCurrBuffer(false) : setPrevBuffer(false);
//         }
//     };

//     // ── Heading label ──────────────────────────────────────────────────────────
//     const getPayrollLabel = () => {
//         if (!payrollRange.start || !payrollRange.end)
//             return `${getMonthName(selectedMonth)} ${selectedYear}`;
//         const s = new Date(payrollRange.start);
//         const e = new Date(payrollRange.end);
//         const sName = s.toLocaleString("default", { month: "long" });
//         const eName = e.toLocaleString("default", { month: "long" });
//         return sName === eName
//             ? `${eName} ${e.getFullYear()}`
//             : `${sName} – ${eName} ${e.getFullYear()}`;
//     };

//     // ── DayCell ────────────────────────────────────────────────────────────────
//     // Renders one calendar cell.
//     // active  = false → striped bg + faded badge, but tooltip still fully shown
//     const DayCell = ({ fullDate, day, record, active }) => {
//         const isToday = fullDate === moment().format("YYYY-MM-DD");
//         const colors = record ? (STATUS_COLORS[record.day_status] ?? null) : null;
//         const short = record ? (DAY_STATUS_SHORT[record.day_status] ?? record.day_status) : null;
//         const full = record ? (DAY_STATUS_FULL[record.day_status] ?? record.day_status) : null;

//         // Tooltip always built — even for disabled cells
//         const tooltip = record
//             ? [
//                 `In Time : ${record.in_time}`,
//                 `Out Time: ${record.out_time}`,
//                 `Status  : ${full}`,
//                 `Duration: ${record.work_duration} hrs`,
//                 !active ? "─────────────────\nOther payroll cycle (view only)" : "",
//             ].filter(Boolean).join("\n")
//             : (!active ? "No record  |  Other payroll cycle" : "");

//         return (
//             <td
//                 title={tooltip}
//                 style={{
//                     padding: "2px 1px",
//                     verticalAlign: "top",
//                     textAlign: "center",
//                     height: "62px",
//                     cursor: tooltip ? "help" : "default",
//                     // Diagonal stripe for disabled cells
//                     background: active
//                         ? "transparent"
//                         : "repeating-linear-gradient(135deg,transparent,transparent 4px,rgba(0,0,0,0.022) 4px,rgba(0,0,0,0.022) 8px)",
//                 }}
//             >
//                 <div className="flex-column-cal calander-height font-size-heading"
//                     style={{
//                         display: "flex",
//                         flexDirection: "column",
//                         alignItems: "center",
//                         gap: "3px",
//                         padding: "3px 1px",
//                         borderRadius: "7px",
//                         height: "100%",
//                     }}
//                 >
//                     {/* Date number circle */}
//                     <span
//                         className="attendance-calander-span font-weight500 font-size-heading"
//                         style={{
//                             width: "27px",
//                             height: "27px",
//                             borderRadius: "50%",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             background: isToday ? "#2576BC" : "transparent",
//                             color: isToday ? "#fff" : active ? "inherit" : "#bbb",
//                             fontSize: "12px",
//                             fontWeight: 500,
//                             flexShrink: 0,
//                         }}
//                     >
//                         {day}
//                     </span>

//                     {/* Status badge — shown for ALL cells regardless of active/disabled */}
//                     {short && colors && (
//                         <span
//                             data-status={record.day_status}
//                             className="attendance-status font-weight500 font-size-label"
//                             style={{
//                                 fontSize: "9.5px",
//                                 fontWeight: 600,
//                                 padding: "1px 5px",
//                                 borderRadius: "4px",
//                                 background: colors.bg,
//                                 color: colors.color,
//                                 maxWidth: "56px",
//                                 whiteSpace: "nowrap",
//                                 overflow: "hidden",
//                                 textOverflow: "ellipsis",
//                                 lineHeight: "1.5",
//                                 // Faded for disabled cells but still visible
//                                 opacity: active ? 1 : 0.45,
//                             }}
//                         >
//                             {short}
//                         </span>
//                     )}
//                 </div>
//             </td>
//         );
//     };

//     // ── renderMonthBlock ───────────────────────────────────────────────────────
//     // Renders ALL days of the month (never clips to payroll window).
//     // active/disabled styling applied per-cell via isActiveDate().
//     const renderMonthBlock = ({ year, month, attendanceMap, isBuffer, isPrev }) => {
//         const monthMoment = moment(`${year}-${month}-01`, "YYYY-MM-DD");
//         const daysInMonth = monthMoment.daysInMonth();          // e.g. 31 for May, 30 for June
//         const firstDOW = parseInt(monthMoment.format("d"), 10);

//         // Badge shown in block header: which date range is "active" in this block
//         // Prev month: payrollStartDay–end  e.g. "25–31"
//         // Curr month: 1–payrollEndDay      e.g. "1–24"
//         const activeFrom = isPrev ? payrollStartDay : 1;
//         const activeTo = isPrev ? daysInMonth : payrollEndDay;

//         const weekHeaders = moment.weekdaysShort().map((d) => (
//             <td
//                 key={d}
//                 className="attendance-calander-heading font-weight500 font-size-heading attendance-calander-heading-td"
//             >
//                 <div className="attendance-calander-heading font-weight500 font-size-heading">
//                     {d}
//                 </div>
//             </td>
//         ));

//         // Leading blank cells for day-of-week offset
//         const blanks = Array.from({ length: firstDOW }, (_, i) => (
//             <td key={`blank-${i}`} className="emptySlot" />
//         ));

//         // All days of the month — active flag decides styling only
//         const dayCells = Array.from({ length: daysInMonth }, (_, idx) => {
//             const d = idx + 1;
//             const fullDate = `${year}-${month}-${String(d).padStart(2, "0")}`;
//             return (
//                 <DayCell
//                     key={fullDate}
//                     fullDate={fullDate}
//                     day={d}
//                     record={attendanceMap.get(fullDate)}
//                     active={isActiveDate(fullDate)}
//                 />
//             );
//         });

//         // Build rows of 7
//         const totalSlots = [...blanks, ...dayCells];
//         const rows = [];
//         for (let i = 0; i < totalSlots.length; i += 7) {
//             rows.push(<tr key={i}>{totalSlots.slice(i, i + 7)}</tr>);
//         }

//         return (
//             <div
//                 style={{
//                     flex: 1,
//                     minWidth: 0,
//                     border: isPrev ? "1px solid #e0e0e0" : "1.5px solid #185FA5",
//                     borderRadius: "10px",
//                     overflow: "hidden",
//                     background: "#fff",
//                 }}
//             >
//                 {/* Block header */}
//                 <div
//                     style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         padding: "9px 13px",
//                         background: isPrev ? "#F5F4F0" : "#EBF4FF",
//                         color: isPrev ? "#5F5E5A" : "#0C447C",
//                     }}
//                 >
//                     <span style={{ fontSize: "13px", fontWeight: 500 }}>
//                         {getMonthName(parseInt(month))} {year}
//                     </span>
//                     <span
//                         style={{
//                             fontSize: "10px",
//                             fontWeight: 500,
//                             padding: "2px 9px",
//                             borderRadius: "20px",
//                             background: isPrev ? "#D3D1C7" : "#B5D4F4",
//                             color: isPrev ? "#444441" : "#0C447C",
//                         }}
//                     >
//                         {activeFrom}–{activeTo}{" "}
//                         <span style={{ fontWeight: 400 }}>active</span>
//                     </span>
//                 </div>

//                 {/* Table */}
//                 {isBuffer ? (
//                     <div style={{ padding: "20px", textAlign: "center" }}>
//                         <Loader container={true} />
//                     </div>
//                 ) : (
//                     <table className="calendar" style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
//                         <tbody className="width-50vw">
//                             <tr>{weekHeaders}</tr>
//                             {rows}
//                         </tbody>
//                     </table>
//                 )}
//             </div>
//         );
//     };

//     // ── Legend ─────────────────────────────────────────────────────────────────
//     const LEGEND = [
//         { key: "ontime", label: "Present" },
//         { key: "late", label: "Late" },
//         { key: "rlm", label: "RLM" },
//         { key: "halfday", label: "Half Day" },
//         { key: "paidleave", label: "Paid Leave" },
//         { key: "weeklyoff", label: "Weekly Off" },
//         { key: "wop", label: "WOP" },
//         { key: "absent", label: "Absent" },
//         { key: "holiday", label: "Holiday" },
//         { key: "shortleave", label: "Short Leave" },
//         { key: "outduty", label: "Out Duty" },
//         { key: "misspunch", label: "Mispunch" },
//     ];

//     // ── Render ─────────────────────────────────────────────────────────────────
//     return (
//         <>
//             <div className="attendance-calendar-container" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>

//                 {/* Top bar */}
//                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} className="bgwhite">
//                     <div className="employee-detail-edit-svg font-weight600 font-size-heading">
//                         {getPayrollLabel()}
//                     </div>
//                     <div className="radialchart-dropdown">
//                         {isLoading ? (
//                             <div className="spinner-small" />
//                         ) : (
//                             <select
//                                 style={{ border: "none", minWidth: "150px" }}
//                                 onChange={handleMonthYearChange}
//                                 value={selectedMonthYear}
//                                 className="month-year-select"
//                             >
//                                 {monthYearOptions.map((opt) => (
//                                     <option key={opt.value} value={opt.value}>{opt.label}</option>
//                                 ))}
//                             </select>
//                         )}
//                     </div>
//                 </div>

//                 {/* Info strip */}
//                 {payrollRange.start && payrollRange.end && (
//                     <div
//                         style={{
//                             display: "flex",
//                             alignItems: "flex-start",
//                             gap: "8px",
//                             background: "#EBF4FF",
//                             borderLeft: "3px solid #185FA5",
//                             borderRadius: "0 6px 6px 0",
//                             padding: "7px 12px",
//                             fontSize: "12px",
//                             color: "#0C447C",
//                         }}
//                     >
//                         <span style={{ flexShrink: 0, marginTop: "1px" }}>ℹ</span>
//                         <span>
//                             Active payroll window:{" "}
//                             <strong>
//                                 {payrollStartDay} {getMonthName(parseInt(prevMonthStr))}
//                                 {" → "}
//                                 {payrollEndDay} {getMonthName(parseInt(selectedMonth))} {selectedYear}
//                             </strong>
//                             . Striped dates belong to a different cycle —{" "}
//                             attendance is still visible, hover any date to see details.
//                         </span>
//                     </div>
//                 )}

//                 {/* Dual month grid */}
//                 <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", alignItems: "start" }}>
//                     {/* LEFT — prev month (full month, e.g. all of May) */}
//                     {renderMonthBlock({
//                         year: prevYear,
//                         month: prevMonthStr,
//                         attendanceMap: prevAttendanceMap,
//                         isBuffer: prevBuffer,
//                         isPrev: true,
//                     })}
//                     {/* RIGHT — curr month (full month, e.g. all of June) */}
//                     {renderMonthBlock({
//                         year: selectedYear,
//                         month: selectedMonth,
//                         attendanceMap: currAttendanceMap,
//                         isBuffer: currBuffer,
//                         isPrev: false,
//                     })}
//                 </div>

//                 {/* Legend */}
//                 <div style={{ display: "flex", flexWrap: "wrap", gap: "6px 12px", paddingTop: "8px", borderTop: "1px solid #f0f0f0" }}>
//                     {LEGEND.map(({ key, label }) => {
//                         const c = STATUS_COLORS[key];
//                         return (
//                             <div key={key} style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "11px", color: "#666" }}>
//                                 <div style={{ width: "9px", height: "9px", borderRadius: "3px", background: c?.bg ?? "#eee", flexShrink: 0 }} />
//                                 {label}
//                             </div>
//                         );
//                     })}
//                     <div style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "11px", color: "#999" }}>
//                         <div style={{
//                             width: "9px", height: "9px", borderRadius: "3px", flexShrink: 0,
//                             background: "repeating-linear-gradient(135deg,#ccc,#ccc 2px,#f0f0f0 2px,#f0f0f0 4px)",
//                             border: "1px dashed #bbb",
//                         }} />
//                         Other cycle
//                     </div>
//                 </div>
//             </div>

//             <ToastContainer
//                 position="top-center" autoClose={1000} hideProgressBar={false}
//                 newestOnTop={true} closeOnClick rtl={false}
//                 pauseOnFocusLoss draggable pauseOnHover
//             />
//         </>
//     );
// };

// export default Calaneder;



// ─── Dual-Month Payroll Calendar ─────────────────────────────────────────────
// Both months render ALL their days (no clipping).
// Active window = payroll_start_date → payroll_end_date from CURR month API only.
// Prev month  : dates < payrollStart  → disabled  (striped, faded, tooltip still works)
// Curr month  : dates > payrollEnd    → disabled
// Disabled cells show full attendance data + tooltip — user can still see everything.
// ─────────────────────────────────────────────────────────────────────────────

// const DAY_STATUS_FULL = {
//     ontime: "Present", outduty: "Out Duty", halfday: "Half Day",
//     paidleave: "Paid Leave", late: "Late", weeklyoff: "Weekly Off",
//     wop: "Weekly Off Present", rlm: "Rectified Late Mark",
//     halfdayleave: "Half Day Leave", paidhalfdayleave: "Paid Half Day Leave",
//     unpaidleave: "Unpaid Leave", shortleave: "Short Leave",
//     unpaidshortleave: "Unpaid Short Leave", unpaidleavehd: "Unpaid Half Day Leave",
//     hdoutduty: "Half Day Out Duty", shortoutduty: "Short Out Duty",
//     misspunch: "Missed Punch", holiday: "Holiday", absent: "Absent",
// };

// const DAY_STATUS_SHORT = {
//     ontime: "Present", outduty: "OutDuty", halfday: "Half Day",
//     paidleave: "PaidLeave", late: "Late", weeklyoff: "WeeklyOff",
//     wop: "WOP", rlm: "RLM", halfdayleave: "Half Day L",
//     paidhalfdayleave: "Paid HDL", unpaidleave: "Unpaid Leave",
//     shortleave: "SL", unpaidshortleave: "Unpaid SL",
//     unpaidleavehd: "Unpaid HDL", hdoutduty: "Half OD",
//     shortoutduty: "ShortOD", misspunch: "Mispunch",
//     holiday: "Holiday", absent: "Absent",
// };

// // Exact same colour tokens as your existing data-status CSS
// const STATUS_COLORS = {
//     ontime: { bg: "#B5D4F4", color: "#0C447C" },
//     late: { bg: "#FAC775", color: "#633806" },
//     rlm: { bg: "#FAC775", color: "#633806" },
//     halfday: { bg: "#F4C0D1", color: "#72243E" },
//     halfdayleave: { bg: "#F4C0D1", color: "#72243E" },
//     paidhalfdayleave: { bg: "#F4C0D1", color: "#72243E" },
//     paidleave: { bg: "#CECBF6", color: "#3C3489" },
//     weeklyoff: { bg: "#D3D1C7", color: "#444441" },
//     wop: { bg: "#C0DD97", color: "#27500A" },
//     absent: { bg: "#F7C1C1", color: "#791F1F" },
//     holiday: { bg: "#CECBF6", color: "#3C3489" },
//     unpaidleave: { bg: "#F5C4B3", color: "#712B13" },
//     unpaidshortleave: { bg: "#F5C4B3", color: "#712B13" },
//     unpaidleavehd: { bg: "#F5C4B3", color: "#712B13" },
//     shortleave: { bg: "#9FE1CB", color: "#085041" },
//     outduty: { bg: "#9FE1CB", color: "#085041" },
//     hdoutduty: { bg: "#9FE1CB", color: "#085041" },
//     shortoutduty: { bg: "#9FE1CB", color: "#085041" },
//     misspunch: { bg: "#FAC775", color: "#633806" },
// };

// const getMonthName = (monthNumber) => {
//     const names = [
//         "January", "February", "March", "April", "May", "June",
//         "July", "August", "September", "October", "November", "December",
//     ];
//     return names[parseInt(monthNumber) - 1];
// };

// // ─────────────────────────────────────────────────────────────────────────────

// const Calaneder = () => {
//     const today = new Date();
//     const currentYear = today.getFullYear();
//     const currentMonth = (today.getMonth() + 1).toString().padStart(2, "0");

//     const [monthYearOptions, setMonthYearOptions] = useState([]);
//     const [selectedYear, setSelectedYear] = useState(currentYear.toString());
//     const [selectedMonth, setSelectedMonth] = useState(currentMonth);
//     const [selectedMonthYear, setSelectedMonthYear] = useState("");
//     const [isLoading, setIsLoading] = useState(true);

//     // Separate lists for each month block
//     const [currAttendanceList, setCurrAttendanceList] = useState([]);
//     const [prevAttendanceList, setPrevAttendanceList] = useState([]);

//     // Payroll window — comes ONLY from curr month API, never overwritten by prev API
//     const [payrollRange, setPayrollRange] = useState({ start: null, end: null });

//     const [currBuffer, setCurrBuffer] = useState(true);
//     const [prevBuffer, setPrevBuffer] = useState(true);

//     // ── O(1) lookup maps ───────────────────────────────────────────────────────
//     const currAttendanceMap = useMemo(() => {
//         const m = new Map();
//         currAttendanceList.forEach((item) => m.set(item.date, item));
//         return m;
//     }, [currAttendanceList]);

//     const prevAttendanceMap = useMemo(() => {
//         const m = new Map();
//         prevAttendanceList.forEach((item) => m.set(item.date, item));
//         return m;
//     }, [prevAttendanceList]);

//     // ── Derived prev-month values ──────────────────────────────────────────────
//     const prevMonthNum = selectedMonth === "01" ? 12 : parseInt(selectedMonth) - 1;
//     const prevYear = selectedMonth === "01"
//         ? (parseInt(selectedYear) - 1).toString()
//         : selectedYear;
//     const prevMonthStr = prevMonthNum.toString().padStart(2, "0");

//     // ── payrollStartDay / payrollEndDay ────────────────────────────────────────
//     // payrollRange.start = "2026-05-25" → startDay = 25  (first active day in prev month)
//     // payrollRange.end   = "2026-06-24" → endDay   = 24  (last  active day in curr month)
//     const payrollStartDay = payrollRange.start
//         ? parseInt(payrollRange.start.split("-")[2], 10) : 25;
//     const payrollEndDay = payrollRange.end
//         ? parseInt(payrollRange.end.split("-")[2], 10) : 24;

//     // ── isActiveDate: is this full "YYYY-MM-DD" inside the payroll window? ─────
//     // NOTE: we compare full ISO strings so cross-month logic is always correct.
//     const isActiveDate = useCallback((fullDate) => {
//         if (!payrollRange.start || !payrollRange.end) return true;
//         return fullDate >= payrollRange.start && fullDate <= payrollRange.end;
//     }, [payrollRange]);

//     // ── Timeline fetch ─────────────────────────────────────────────────────────
//     useEffect(() => {
//         const getTimelineData = async () => {
//             setIsLoading(true);
//             try {
//                 const emp_code = sessionStorage.getItem("emp_code");
//                 const res = await axios.get(
//                     `${BASE_URL}/wfm/employee-latest-timeline/${emp_code}/`
//                 );
//                 generateMonthYearOptions(res.data);
//             } catch (err) {
//                 handleErrorToast(err);
//             } finally {
//                 setIsLoading(false);
//             }
//         };
//         getTimelineData();
//     }, []); // eslint-disable-line react-hooks/exhaustive-deps

//     const generateMonthYearOptions = (data) => {
//         const options = [];
//         const joining = new Date(data.joining_date);
//         const joiningY = joining.getFullYear();
//         const joiningM = joining.getMonth() + 1;
//         const latest = data.last_attendance_date
//             ? new Date(data.last_attendance_date) : new Date();
//         const latestY = latest.getFullYear();
//         const latestM = latest.getMonth() + 1;

//         for (let y = joiningY; y <= latestY; y++) {
//             const startM = y === joiningY ? joiningM : 1;
//             const endM = y === latestY ? latestM : 12;
//             for (let m = startM; m <= endM; m++) {
//                 options.push({
//                     value: `${y}-${m.toString().padStart(2, "0")}`,
//                     label: `${getMonthName(m)} ${y}`,
//                 });
//             }
//         }
//         options.sort((a, b) => a.value.localeCompare(b.value));
//         setMonthYearOptions(options);

//         const currentValue = `${currentYear}-${currentMonth}`;
//         const initialOption =
//             options.find((o) => o.value === currentValue) || options[options.length - 1];
//         if (initialOption) setSelectedMonthYear(initialOption.value);
//     };

//     const handleMonthYearChange = (e) => {
//         const [year, month] = e.target.value.split("-");
//         setSelectedMonthYear(e.target.value);
//         setSelectedYear(year);
//         setSelectedMonth(month);
//     };

//     // ── Fetch both months whenever selection changes ───────────────────────────
//     useEffect(() => {
//         if (selectedMonth && selectedYear) {
//             fetchAttendance(selectedMonth, selectedYear, "curr");
//             fetchAttendance(prevMonthStr, prevYear, "prev");
//         }
//     }, [selectedMonth, selectedYear]); // eslint-disable-line react-hooks/exhaustive-deps

//     const fetchAttendance = async (month, year, which) => {
//         which === "curr" ? setCurrBuffer(true) : setPrevBuffer(true);
//         try {
//             const emp_code = sessionStorage.getItem("emp_code");
//             const res = await axios.get(
//                 `${BASE_URL}/wfm/attendancefilterbyEmpByMonth/v2/${emp_code}/${month}/${year}/`
//             );
//             const records = res.data.data ?? [];

//             if (which === "curr") {
//                 // ── payroll window from curr API only ──────────────────────────
//                 setPayrollRange({
//                     start: res.data.payroll_start_date,  // "2026-05-25"
//                     end: res.data.payroll_end_date,    // "2026-06-24"
//                 });
//                 setCurrAttendanceList(records);
//             } else {
//                 // prev month: store records only — do NOT touch payrollRange
//                 setPrevAttendanceList(records);
//             }
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             which === "curr" ? setCurrBuffer(false) : setPrevBuffer(false);
//         }
//     };

//     // ── Heading label ──────────────────────────────────────────────────────────
//     const getPayrollLabel = () => {
//         if (!payrollRange.start || !payrollRange.end)
//             return `${getMonthName(selectedMonth)} ${selectedYear}`;
//         const s = new Date(payrollRange.start);
//         const e = new Date(payrollRange.end);
//         const sName = s.toLocaleString("default", { month: "long" });
//         const eName = e.toLocaleString("default", { month: "long" });
//         return sName === eName
//             ? `${eName} ${e.getFullYear()}`
//             : `${sName} – ${eName} ${e.getFullYear()}`;
//     };

//     // ── DayCell ────────────────────────────────────────────────────────────────
//     // Renders one calendar cell.
//     // active  = false → striped bg + faded badge, but tooltip still fully shown
//     const DayCell = ({ fullDate, day, record, active }) => {
//         const isToday = fullDate === moment().format("YYYY-MM-DD");
//         const colors = record ? (STATUS_COLORS[record.day_status] ?? null) : null;
//         const short = record ? (DAY_STATUS_SHORT[record.day_status] ?? record.day_status) : null;
//         const full = record ? (DAY_STATUS_FULL[record.day_status] ?? record.day_status) : null;

//         // Tooltip always built — even for disabled cells
//         const tooltip = record
//             ? [
//                 `In Time : ${record.in_time}`,
//                 `Out Time: ${record.out_time}`,
//                 `Status  : ${full}`,
//                 `Duration: ${record.work_duration} hrs`,
//                 !active ? "─────────────────\nOther payroll cycle (view only)" : "",
//             ].filter(Boolean).join("\n")
//             : (!active ? "No record  |  Other payroll cycle" : "");

//         return (
//             <td
//                 title={tooltip}
//                 style={{
//                     padding: "2px 1px",
//                     verticalAlign: "top",
//                     textAlign: "center",
//                     height: "62px",
//                     cursor: tooltip ? "help" : "default",
//                     // Diagonal stripe for disabled cells
//                     background: active
//                         ? "transparent"
//                         : "repeating-linear-gradient(135deg,transparent,transparent 4px,rgba(0,0,0,0.022) 4px,rgba(0,0,0,0.022) 8px)",
//                 }}
//             >
//                 <div className="flex-column-cal calander-height font-size-heading"
//                     style={{
//                         display: "flex",
//                         flexDirection: "column",
//                         alignItems: "center",
//                         gap: "3px",
//                         padding: "3px 1px",
//                         borderRadius: "7px",
//                         height: "100%",
//                     }}
//                 >
//                     {/* Date number circle */}
//                     <span
//                         className="attendance-calander-span font-weight500 font-size-heading"
//                         style={{
//                             width: "27px",
//                             height: "27px",
//                             borderRadius: "50%",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             background: isToday ? "#2576BC" : "transparent",
//                             color: isToday ? "#fff" : active ? "inherit" : "#bbb",
//                             fontSize: "12px",
//                             fontWeight: 500,
//                             flexShrink: 0,
//                         }}
//                     >
//                         {day}
//                     </span>

//                     {/* Status badge — shown for ALL cells regardless of active/disabled */}
//                     {short && colors && (
//                         <span
//                             data-status={record.day_status}
//                             className="attendance-status font-weight500 font-size-label"
//                             style={{
//                                 fontSize: "9.5px",
//                                 fontWeight: 600,
//                                 padding: "1px 5px",
//                                 borderRadius: "4px",
//                                 background: colors.bg,
//                                 color: colors.color,
//                                 maxWidth: "56px",
//                                 whiteSpace: "nowrap",
//                                 overflow: "hidden",
//                                 textOverflow: "ellipsis",
//                                 lineHeight: "1.5",
//                                 // Faded for disabled cells but still visible
//                                 opacity: active ? 1 : 0.45,
//                             }}
//                         >
//                             {short}
//                         </span>
//                     )}
//                 </div>
//             </td>
//         );
//     };

//     // ── renderMonthBlock ───────────────────────────────────────────────────────
//     // Renders ALL days of the month (never clips to payroll window).
//     // active/disabled styling applied per-cell via isActiveDate().
//     const renderMonthBlock = ({ year, month, attendanceMap, isBuffer, isPrev }) => {
//         const monthMoment = moment(`${year}-${month}-01`, "YYYY-MM-DD");
//         const daysInMonth = monthMoment.daysInMonth();          // e.g. 31 for May, 30 for June
//         const firstDOW = parseInt(monthMoment.format("d"), 10);

//         // Badge shown in block header: which date range is "active" in this block
//         // Prev month: payrollStartDay–end  e.g. "25–31"
//         // Curr month: 1–payrollEndDay      e.g. "1–24"
//         const activeFrom = isPrev ? payrollStartDay : 1;
//         const activeTo = isPrev ? daysInMonth : payrollEndDay;

//         const weekHeaders = moment.weekdaysShort().map((d) => (
//             <td
//                 key={d}
//                 className="attendance-calander-heading font-weight500 font-size-heading attendance-calander-heading-td"
//             >
//                 <div className="attendance-calander-heading font-weight500 font-size-heading">
//                     {d}
//                 </div>
//             </td>
//         ));

//         // Leading blank cells for day-of-week offset
//         const blanks = Array.from({ length: firstDOW }, (_, i) => (
//             <td key={`blank-${i}`} className="emptySlot" />
//         ));

//         // All days of the month — active flag decides styling only
//         const dayCells = Array.from({ length: daysInMonth }, (_, idx) => {
//             const d = idx + 1;
//             const fullDate = `${year}-${month}-${String(d).padStart(2, "0")}`;
//             return (
//                 <DayCell
//                     key={fullDate}
//                     fullDate={fullDate}
//                     day={d}
//                     record={attendanceMap.get(fullDate)}
//                     active={isActiveDate(fullDate)}
//                 />
//             );
//         });

//         // Build rows of 7
//         const totalSlots = [...blanks, ...dayCells];
//         const rows = [];
//         for (let i = 0; i < totalSlots.length; i += 7) {
//             rows.push(<tr key={i}>{totalSlots.slice(i, i + 7)}</tr>);
//         }

//         return (
//             <div
//                 style={{
//                     flex: 1,
//                     minWidth: 0,
//                     border: isPrev ? "1px solid #e0e0e0" : "1.5px solid #185FA5",
//                     borderRadius: "10px",
//                     overflow: "hidden",
//                     background: "#fff",
//                 }}
//             >
//                 {/* Block header */}
//                 <div
//                     style={{
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         padding: "9px 13px",
//                         background: isPrev ? "#F5F4F0" : "#EBF4FF",
//                         color: isPrev ? "#5F5E5A" : "#0C447C",
//                     }}
//                 >
//                     <span style={{ fontSize: "13px", fontWeight: 500 }}>
//                         {getMonthName(parseInt(month))} {year}
//                     </span>
//                     <span
//                         style={{
//                             fontSize: "10px",
//                             fontWeight: 500,
//                             padding: "2px 9px",
//                             borderRadius: "20px",
//                             background: isPrev ? "#D3D1C7" : "#B5D4F4",
//                             color: isPrev ? "#444441" : "#0C447C",
//                         }}
//                     >
//                         {activeFrom}–{activeTo}{" "}
//                         <span style={{ fontWeight: 400 }}>active</span>
//                     </span>
//                 </div>

//                 {/* Table */}
//                 {isBuffer ? (
//                     <div style={{ padding: "20px", textAlign: "center" }}>
//                         <Loader container={true} />
//                     </div>
//                 ) : (
//                     <table className="calendar" style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
//                         <tbody className="width-50vw">
//                             <tr>{weekHeaders}</tr>
//                             {rows}
//                         </tbody>
//                     </table>
//                 )}
//             </div>
//         );
//     };

//     // ── Legend ─────────────────────────────────────────────────────────────────
//     const LEGEND = [
//         { key: "ontime", label: "Present" },
//         { key: "late", label: "Late" },
//         { key: "rlm", label: "RLM" },
//         { key: "halfday", label: "Half Day" },
//         { key: "paidleave", label: "Paid Leave" },
//         { key: "weeklyoff", label: "Weekly Off" },
//         { key: "wop", label: "WOP" },
//         { key: "absent", label: "Absent" },
//         { key: "holiday", label: "Holiday" },
//         { key: "shortleave", label: "Short Leave" },
//         { key: "outduty", label: "Out Duty" },
//         { key: "misspunch", label: "Mispunch" },
//     ];

//     // ── Render ─────────────────────────────────────────────────────────────────
//     return (
//         <>
//             <div className="attendance-calendar-container" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>

//                 {/* Top bar */}
//                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }} className="bgwhite">
//                     <div className="employee-detail-edit-svg font-weight600 font-size-heading">
//                         {getPayrollLabel()}
//                     </div>
//                     <div className="radialchart-dropdown">
//                         {isLoading ? (
//                             <div className="spinner-small" />
//                         ) : (
//                             <select
//                                 style={{ border: "none", minWidth: "150px" }}
//                                 onChange={handleMonthYearChange}
//                                 value={selectedMonthYear}
//                                 className="month-year-select"
//                             >
//                                 {monthYearOptions.map((opt) => (
//                                     <option key={opt.value} value={opt.value}>{opt.label}</option>
//                                 ))}
//                             </select>
//                         )}
//                     </div>
//                 </div>

//                 {/* Info strip */}
//                 {payrollRange.start && payrollRange.end && (
//                     <div
//                         style={{
//                             display: "flex",
//                             alignItems: "flex-start",
//                             gap: "8px",
//                             background: "#EBF4FF",
//                             borderLeft: "3px solid #185FA5",
//                             borderRadius: "0 6px 6px 0",
//                             padding: "7px 12px",
//                             fontSize: "12px",
//                             color: "#0C447C",
//                         }}
//                     >
//                         <span style={{ flexShrink: 0, marginTop: "1px" }}>ℹ</span>
//                         <span>
//                             Active payroll window:{" "}
//                             <strong>
//                                 {payrollStartDay} {getMonthName(parseInt(prevMonthStr))}
//                                 {" → "}
//                                 {payrollEndDay} {getMonthName(parseInt(selectedMonth))} {selectedYear}
//                             </strong>
//                             . Striped dates belong to a different cycle —{" "}
//                             attendance is still visible, hover any date to see details.
//                         </span>
//                     </div>
//                 )}

//                 {/* Dual month grid */}
//                 <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", alignItems: "start" }}>
//                     {/* LEFT — prev month (full month, e.g. all of May) */}
//                     {renderMonthBlock({
//                         year: prevYear,
//                         month: prevMonthStr,
//                         attendanceMap: prevAttendanceMap,
//                         isBuffer: prevBuffer,
//                         isPrev: true,
//                     })}
//                     {/* RIGHT — curr month (full month, e.g. all of June) */}
//                     {renderMonthBlock({
//                         year: selectedYear,
//                         month: selectedMonth,
//                         attendanceMap: currAttendanceMap,
//                         isBuffer: currBuffer,
//                         isPrev: false,
//                     })}
//                 </div>

//                 {/* Legend */}
//                 <div style={{ display: "flex", flexWrap: "wrap", gap: "6px 12px", paddingTop: "8px", borderTop: "1px solid #f0f0f0" }}>
//                     {LEGEND.map(({ key, label }) => {
//                         const c = STATUS_COLORS[key];
//                         return (
//                             <div key={key} style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "11px", color: "#666" }}>
//                                 <div style={{ width: "9px", height: "9px", borderRadius: "3px", background: c?.bg ?? "#eee", flexShrink: 0 }} />
//                                 {label}
//                             </div>
//                         );
//                     })}
//                     <div style={{ display: "flex", alignItems: "center", gap: "5px", fontSize: "11px", color: "#999" }}>
//                         <div style={{
//                             width: "9px", height: "9px", borderRadius: "3px", flexShrink: 0,
//                             background: "repeating-linear-gradient(135deg,#ccc,#ccc 2px,#f0f0f0 2px,#f0f0f0 4px)",
//                             border: "1px dashed #bbb",
//                         }} />
//                         Other cycle
//                     </div>
//                 </div>
//             </div>

//             <ToastContainer
//                 position="top-center" autoClose={1000} hideProgressBar={false}
//                 newestOnTop={true} closeOnClick rtl={false}
//                 pauseOnFocusLoss draggable pauseOnHover
//             />
//         </>
//     );
// };

// export default Calaneder;

// ─── Dual-Month Payroll Calendar — UI matching HRMS1.png ────────────────────
// • Dot indicators per status (like screenshot) instead of text badges
// • Summary strip: Present / Absent / Leave / Weekly Off / Attendance%
// • Both months render ALL their days (no clipping)
// • Active window = payroll_start_date → payroll_end_date from CURR month API only
// • Outside payroll cycle cells → greyed out with diagonal stripe, WO/status still shown
// • Hover tooltip on every cell (active + disabled)
// • Today → blue filled circle
// ─────────────────────────────────────────────────────────────────────────────


// ─── Calendar.jsx — Exact UI match to HRMS screenshot ───────────────────────
// Layout: Single card → [Prev Month Cal] [Curr Month Cal (blue border)] [Today Panel]
// • Both calendars same height (aligned bottom via stretch)
// • Overflow dates from adjacent months shown greyed (like screenshot)
// • Stat cards: Present / Absent / Leave / Weekly Off / Attendance%
// • Today panel: status, check-in, check-out, view timeline
// • Dots for status, WO text for weekly off
// • Outside payroll cycle → diagonal stripe + opacity 0.38, tooltip still works
// ─────────────────────────────────────────────────────────────────────────────

const DAY_STATUS_FULL = {
    ontime: "Present", outduty: "Out Duty", halfday: "Half Day", paidleave: "Paid Leave",
    late: "Late", weeklyoff: "Weekly Off", wop: "Weekly Off Present", rlm: "Rectified Late Mark",
    halfdayleave: "Half Day Leave", paidhalfdayleave: "Paid Half Day Leave",
    unpaidleave: "Unpaid Leave", shortleave: "Short Leave", unpaidshortleave: "Unpaid Short Leave",
    unpaidleavehd: "Unpaid Half Day Leave", hdoutduty: "Half Day Out Duty",
    shortoutduty: "Short Out Duty", misspunch: "Missed Punch", holiday: "Holiday", absent: "Absent",
};

// Dot colour per status
// const STATUS_DOT = {
//     ontime: "#3DB88B", late: "#3DB88B", rlm: "#3DB88B", wop: "#3DB88B",
//     halfday: "#F5A623", halfdayleave: "#F5A623", paidhalfdayleave: "#F5A623", misspunch: "#F5A623",
//     outduty: "#3B82F6", hdoutduty: "#3B82F6", shortoutduty: "#3B82F6",
//     paidleave: "#A78BFA", unpaidleave: "#A78BFA", shortleave: "#A78BFA",
//     holiday: "#A78BFA", unpaidshortleave: "#A78BFA", unpaidleavehd: "#A78BFA",
//     weeklyoff: "#94A3B8",
//     absent: "#EF4444",
// };

const STATUS_DOT = {
    // Present
    ontime: "#22C55E",

    // Late
    late: "#F97316",

    // Rectified Late Mark
    rlm: "#588de2",

    // Weekly Off Present
    wop: "#38995c",

    // Half Day
    halfday: "#F59E0B",
    halfdayleave: "#F59E0B",
    paidhalfdayleave: "#F59E0B",

    // Out Duty
    outduty: "#2563EB",
    hdoutduty: "#2563EB",
    shortoutduty: "#2563EB",

    // Paid Leave
    paidleave: "#075e41",

    // Unpaid Leave
    unpaidleave: "#8B5CF6",
    unpaidleavehd: "#8B5CF6",
    unpaidshortleave: "#8B5CF6",

    // Short Leave
    shortleave: "#b906b9",

    // Holiday
    holiday: "#5112e4",

    // Weekly Off
    weeklyoff: "#94A3B8",

    // Miss Punch
    misspunch: "#ffa200",

    // Absent
    absent: "#EF4444",
};

const STATUS_BADGE = {
    ontime: {
        bg: "#F0FDF4",
        text: "#166534",
        dot: "#22C55E",
    },

    late: {
        bg: "#FFF7ED",
        text: "#9A3412",
        dot: "#F97316",
    },

    rlm: {
        bg: "#EFF6FF",
        text: "#1D4ED8",
        dot: "#588de2",
    },

    absent: {
        bg: "#FEF2F2",
        text: "#991B1B",
        dot: "#EF4444",
    },

    holiday: {
        bg: "#F5F3FF",
        text: "#6D28D9",
        dot: "#5112e4",
    },

    weeklyoff: {
        bg: "#F8FAFC",
        text: "#475569",
        dot: "#94A3B8",
    },

    paidleave: {
        bg: "#ECFDF5",
        text: "#047857",
        dot: "#075e41",
    },

    shortleave: {
        bg: "#F0FDFA",
        text: "#7c057c",
        dot: "#b906b9",
    },

    halfday: {
        bg: "#FFFBEB",
        text: "#92400E",
        dot: "#F59E0B",
    },

    halfdayleave: {
        bg: "#FFFBEB",
        text: "#92400E",
        dot: "#F59E0B",
    },

    paidhalfdayleave: {
        bg: "#FFFBEB",
        text: "#92400E",
        dot: "#F59E0B",
    },

    outduty: {
        bg: "#EEF2FF",
        text: "#0e49c9",
        dot: "#2563EB",
    },

    hdoutduty: {
        bg: "#EEF2FF",
        text: "#0e49c9",
        dot: "#2563EB",
    },

    shortoutduty: {
        bg: "#EEF2FF",
        text: "#0e49c9",
        dot: "#2563EB",
    },
};

const WO_SET = new Set(["weeklyoff", "wop"]);
const PRESENT_SET = new Set(["ontime", "late", "rlm", "wop", "halfday", "halfdayleave", "paidhalfdayleave", "hdoutduty", "shortoutduty", "outduty", "shortleave", "misspunch"]);
const ABSENT_SET = new Set(["absent"]);
const LEAVE_SET = new Set(["paidleave", "unpaidleave", "shortleave", "halfdayleave", "paidhalfdayleave", "unpaidshortleave", "unpaidleavehd"]);

const getMonthName = (n) => ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"][parseInt(n) - 1];

// ─────────────────────────────────────────────────────────────────────────────

const Calaneder = ({ customWidth = 'auto' }) => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = (today.getMonth() + 1).toString().padStart(2, "0");
    const todayFull = moment().format("YYYY-MM-DD");
    const todayDateNum = today.getDate();
    const todayMonthLong = today.toLocaleString("default", { month: "long" });

    const [monthYearOptions, setMonthYearOptions] = useState([]);
    const [selectedYear, setSelectedYear] = useState(currentYear.toString());
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);
    const [selectedMonthYear, setSelectedMonthYear] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    const [currAttendanceList, setCurrAttendanceList] = useState([]);
    const [prevAttendanceList, setPrevAttendanceList] = useState([]);
    const [payrollRange, setPayrollRange] = useState({ start: null, end: null });
    const [currBuffer, setCurrBuffer] = useState(true);
    const [prevBuffer, setPrevBuffer] = useState(true);

    // O(1) maps
    const currMap = useMemo(() => { const m = new Map(); currAttendanceList.forEach(i => m.set(i.date, i)); return m; }, [currAttendanceList]);
    const prevMap = useMemo(() => { const m = new Map(); prevAttendanceList.forEach(i => m.set(i.date, i)); return m; }, [prevAttendanceList]);
    // Derived prev month
    const prevMonthNum = selectedMonth === "01" ? 12 : parseInt(selectedMonth) - 1;
    const prevYear = selectedMonth === "01" ? (parseInt(selectedYear) - 1).toString() : selectedYear;
    const prevMonthStr = prevMonthNum.toString().padStart(2, "0");

    const patchedPrevMap = useMemo(() => {
        const m = new Map(prevMap); // start with May's own data (1–24)
        if (payrollRange.start) {
            currMap.forEach((record, date) => {
                const recordMonth = date.substring(0, 7);       // "2026-05"
                const prevMonthKey = `${prevYear}-${prevMonthStr}`; // "2026-05"
                if (recordMonth === prevMonthKey) {
                    m.set(date, record); // patch May 25–31 from June API
                }
            });
        }
        return m;
    }, [prevMap, currMap, payrollRange.start, prevYear, prevMonthStr]);



    // Payroll boundary days
    const payrollStartDay = payrollRange.start ? parseInt(payrollRange.start.split("-")[2], 10) : 25;
    const payrollEndDay = payrollRange.end ? parseInt(payrollRange.end.split("-")[2], 10) : 24;

    const isSingleMonthCycle = useMemo(() => {
        if (!payrollRange.start || !payrollRange.end) return false;


        const startMonth = payrollRange.start.substring(0, 7); // e.g., "2026-05"
        const endMonth = payrollRange.end.substring(0, 7);


        // True if the cycle is entirely within one month OR starts on the 1st
        return startMonth === endMonth || parseInt(payrollRange.start.split("-")[2], 10) === 1;
    }, [payrollRange]);


    const isActiveDate = useCallback((fullDate) => {
        if (!payrollRange.start || !payrollRange.end) return true;
        return fullDate >= payrollRange.start && fullDate <= payrollRange.end;
    }, [payrollRange]);

    // Summary stats (active window only)
    const stats = useMemo(() => {
        let present = 0, absent = 0, leave = 0, wo = 0, working = 0;
        [currMap, patchedPrevMap].forEach(map => {
            map.forEach((rec, date) => {
                if (!isActiveDate(date)) return;
                const s = rec.day_status;
                if (PRESENT_SET.has(s)) present++;
                if (ABSENT_SET.has(s)) absent++;
                if (LEAVE_SET.has(s)) leave++;
                if (WO_SET.has(s)) wo++;
                if (!WO_SET.has(s) && s !== "holiday") working++;
            });
        });
        return { present, absent, leave, wo, att: working > 0 ? Math.round(present / working * 100) : 0 };
        // }, [currMap, prevMap, isActiveDate]);
    }, [currMap, patchedPrevMap, isActiveDate]);

    // Today's record (for Today panel)
    // const todayRecord = currMap.get(todayFull) || prevMap.get(todayFull) || null;
    const [todayRecord, setTodayRecord] = useState(null);

    // Timeline fetch
    useEffect(() => {
        const fetch = async () => {
            setIsLoading(true);
            try {
                const emp = sessionStorage.getItem("emp_code");
                const res = await axios.get(`${BASE_URL}/wfm/employee-latest-timeline/${emp}/`);
                generateOptions(res.data);
            } catch (e) { handleErrorToast(e); }
            finally { setIsLoading(false); }
        };
        fetch();
    }, []); // eslint-disable-line

    const generateOptions = (data) => {
        const opts = [];
        const j = new Date(data.joining_date);
        const jY = j.getFullYear(), jM = j.getMonth() + 1;
        const l = data.last_attendance_date ? new Date(data.last_attendance_date) : new Date();
        const lY = l.getFullYear(), lM = l.getMonth() + 1;
        for (let y = jY; y <= lY; y++) {
            const s = y === jY ? jM : 1, e = y === lY ? lM : 12;
            for (let m = s; m <= e; m++) opts.push({ value: `${y}-${m.toString().padStart(2, "0")}`, label: `${getMonthName(m)} ${y}` });
        }
        opts.sort((a, b) => a.value.localeCompare(b.value));
        setMonthYearOptions(opts);
        const cur = `${currentYear}-${currentMonth}`;
        const init = opts.find(o => o.value === cur) || opts[opts.length - 1];
        if (init) setSelectedMonthYear(init.value);
    };

    const handleChange = (e) => {
        const [year, month] = e.target.value.split("-");
        setSelectedMonthYear(e.target.value);
        setSelectedYear(year); setSelectedMonth(month);
    };

    useEffect(() => {
        if (selectedMonth && selectedYear) {
            fetchAtt(selectedMonth, selectedYear, "curr");
            fetchAtt(prevMonthStr, prevYear, "prev");
        }
    }, [selectedMonth, selectedYear]); // eslint-disable-line

    // const fetchAtt = async (month, year, which) => {
    //     which === "curr" ? setCurrBuffer(true) : setPrevBuffer(true);
    //     try {
    //         const emp = sessionStorage.getItem("emp_code");
    //         // const res = await axios.get(`${BASE_URL}/wfm/attendancefilterbyEmpByMonth/v2/${emp}/${month}/${year}/`);
    //         const res = await axios.get(`${BASE_URL}/wfm/attendancefilterbyEmpByMonth/v2/${emp}/${month}/${year}/`);
    //         const records = res.data.data ?? [];
    //         if (which === "curr") {
    //             setPayrollRange({ start: res.data.payroll_start_date, end: res.data.payroll_end_date });
    //             setCurrAttendanceList(records);
    //         } else {
    //             setPrevAttendanceList(records); // never touch payrollRange here
    //         }
    //     } catch (e) { handleErrorToast(e); }
    //     finally { which === "curr" ? setCurrBuffer(false) : setPrevBuffer(false); }
    // };

    // ── DayCell ────────────────────────────────────────────────────────────────



    const fetchAtt = async (month, year, which) => {
        which === "curr" ? setCurrBuffer(true) : setPrevBuffer(true);
        try {
            const emp = sessionStorage.getItem("emp_code");
            const res = await axios.get(`${BASE_URL}/wfm/attendancefilterbyEmpByMonth/v2/${emp}/${month}/${year}/`);
            const records = res.data.data ?? [];

            // Capture today's record persistently ──
            const foundToday = records.find(r => r.date === todayFull);
            if (foundToday) {
                setTodayRecord(foundToday);
            }


            if (which === "curr") {
                const cycleEnd = res.data.payroll_end_date;

                // const cycleEnd = res.data.payroll_end_date;

                // 1. Auto-Forwarding Check
                if (isInitialLoad && cycleEnd && todayFull > cycleEnd) {
                    setIsInitialLoad(false); // Prevent loop


                    // Calculate next month
                    let nextM = parseInt(month) + 1;
                    let nextY = parseInt(year);
                    if (nextM > 12) {
                        nextM = 1;
                        nextY++;
                    }


                    const nextMonthStr = nextM.toString().padStart(2, "0");
                    const nextYearStr = nextY.toString();
                    const nextVal = `${nextYearStr}-${nextMonthStr}`;


                    // Add the new month to dropdown options if it isn't generated by timeline
                    setMonthYearOptions(prev => {
                        if (!prev.find(o => o.value === nextVal)) {
                            const newOpts = [...prev, { value: nextVal, label: `${getMonthName(nextM)} ${nextYearStr}` }];
                            return newOpts.sort((a, b) => a.value.localeCompare(b.value));
                        }
                        return prev;
                    });


                    // 2. Shift the calendar to the new month
                    setSelectedMonthYear(nextVal);
                    setSelectedYear(nextYearStr);
                    setSelectedMonth(nextMonthStr);


                    // Exit out early! Do not set the old month's data. The useEffect will handle the new fetch.
                    return;
                    return;
                }

                // Normal behavior if we don't need to auto-forward
                setIsInitialLoad(false);
                setIsInitialLoad(false);
                setPayrollRange({ start: res.data.payroll_start_date, end: res.data.payroll_end_date });
                setCurrAttendanceList(records);
            } else {
                setPrevAttendanceList(records);
            }
        } catch (e) { handleErrorToast(e); }
        finally { which === "curr" ? setCurrBuffer(false) : setPrevBuffer(false); }
    };

    const DayCell = ({ fullDate, day, record, active, isOverflow }) => {
        const isToday = fullDate === todayFull;
        const dotColor = record ? (STATUS_DOT[record.day_status] ?? null) : null;
        const isWO = record && WO_SET.has(record.day_status);
        // const fullSt = record ? (DAY_STATUS_FULL[record.day_status] ?? record.day_status) : null;
        const fullSt = record ? record.day_status : null;

        // const tooltip = record
        //     ? [`Status  : ${fullSt}`,
        //     record.in_time !== "-" ? `In Time : ${record.in_time}` : null,
        //     record.out_time !== "-" ? `Out Time: ${record.out_time}` : null,
        //     record.work_duration && record.work_duration !== "0" ? `Duration: ${record.work_duration} hrs` : null,
        //     !active ? "── Outside payroll cycle (view only) ──" : null,
        //     ].filter(Boolean).join("\n")
        //     : (!active ? "Outside payroll cycle" : "");

        const tooltip = record
            ? [
                `Attendance Status : ${record.attendence_status ?? "-"}`,
                `Day Status        : ${fullSt ?? "-"}`,
                record.in_time && record.in_time !== "-" && record.in_time !== null
                    ? `In Time           : ${record.in_time}` : null,
                record.out_time && record.out_time !== "-" && record.out_time !== null
                    ? `Out Time          : ${record.out_time}` : null,
                record.work_duration && record.work_duration !== "0" && record.work_duration !== null
                    ? `Work Duration     : ${record.work_duration} hrs` : null,
                !active ? "──────────────────────\nOutside active payroll cycle (view only)" : null,
            ].filter(Boolean).join("\n")
            : isOverflow
                ? ""
                : (!active ? "No record — outside payroll cycle" : "");

        return (
            <td
                title={tooltip}
                style={{
                    padding: "1px",
                    verticalAlign: "top",
                    textAlign: "center",
                    height: "54px",
                    width: "14.28%",
                    cursor: record ? "help" : "default",
                    // background: isOverflow
                    //     ? "transparent"
                    //     : active
                    //         ? "transparent"
                    //         : fullDate >= payrollRange.start
                    //             ? "white"
                    //             : "repeating-linear-gradient(135deg,transparent,transparent 3px,rgba(0,0,0,0.025) 3px,rgba(0,0,0,0.025) 6px)",
                    background: isOverflow
                        ? "transparent"
                        : active
                            ? "transparent"
                            : "repeating-linear-gradient(135deg,transparent,transparent 3px,rgba(0,0,0,0.025) 3px,rgba(0,0,0,0.025) 6px)",
                }}
            >
                <div style={{
                    display: "flex", flexDirection: "column", alignItems: "center",
                    paddingTop: "4px", height: "100%", gap: "3px",
                    opacity: isOverflow ? 1 : active ? 1 : 0.38,
                }}>
                    {/* <span style={{
                        width: "26px", height: "26px", borderRadius: "50%",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: "12px", fontWeight: isToday ? 600 : 500,
                        background: isToday ? "#3B82F6" : "transparent",
                        color: isToday ? "#fff" : isOverflow ? "#CBD5E1" : active ? "#000000" : "#94A3B8",
                        flexShrink: 0, lineHeight: 1,
                    }}>
                        {day}
                    </span> */}
                    <span style={{
                        width: "26px", height: "26px",
                        borderRadius: isToday ? "50%" : fullDate === payrollRange.start ? "5px" : "50%",
                        display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: "12px", fontWeight: isToday || fullDate === payrollRange.start ? 600 : 400,
                        background: isToday ? "#3B82F6" : fullDate === payrollRange.start ? "#EBF4FF" : "transparent",
                        color: isToday ? "#fff" : fullDate === payrollRange.start ? "#2563EB" : isOverflow ? "#CBD5E1" : active ? "#000000" : "#94A3B8",
                        border: fullDate === payrollRange.start ? "1.5px solid #2563EB" : "none",
                        flexShrink: 0, lineHeight: 1,
                    }}>
                        {day}
                    </span>
                    {!isOverflow && isWO && (
                        <span style={{ fontSize: "9px", fontWeight: 600, color: "#94A3B8", letterSpacing: ".02em", lineHeight: 1 }}>
                            WO
                        </span>
                    )}
                    {!isOverflow && dotColor && !isWO && (
                        <span style={{ width: "7px", height: "7px", borderRadius: "50%", background: dotColor, display: "inline-block", flexShrink: 0 }} />
                    )}
                </div>
            </td>
        );
    };

    // ── renderMonthTable: renders ALL days + overflow dates from adjacent months ─
    const renderMonthTable = (year, month, attendanceMap, isBuffer) => {
        if (isBuffer) return <div style={{
            minWidth: "310px",
            width: "100%",
            height: "280px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
        }}>
            <Loader container={true} />
        </div>;

        const mm = moment(`${year}-${month}-01`, "YYYY-MM-DD");
        const daysInMon = mm.daysInMonth();
        const firstDOW = parseInt(mm.format("d"), 10);

        // prev month overflow
        const prevMo = month === "01" ? "12" : (parseInt(month) - 1).toString().padStart(2, "0");
        const prevYr = month === "01" ? (parseInt(year) - 1).toString() : year;
        const prevDim = moment(`${prevYr}-${prevMo}-01`, "YYYY-MM-DD").daysInMonth();

        const headers = moment.weekdaysShort().map(d => (
            <td key={d} style={{ textAlign: "center", padding: "4px 0 7px", fontSize: "10px", fontWeight: 500, color: "#94A3B8" }}>
                {d}
            </td>
        ));

        // leading overflow cells (prev month tail)
        // const overflowLeading = Array.from({ length: firstDOW }, (_, i) => {
        //     const d = prevDim - firstDOW + 1 + i;
        //     return <DayCell key={`ov-l-${i}`} fullDate={`${prevYr}-${prevMo}-${String(d).padStart(2, "0")}`} day={d} record={null} active={false} isOverflow={true} />;
        // });
        const overflowLeading = Array.from({ length: firstDOW }, (_, i) => (
            <td key={`ov-l-${i}`} style={{ padding: "1px", height: "54px", width: "14.28%" }} />
        ));

        // actual month days
        const dayCells = Array.from({ length: daysInMon }, (_, idx) => {
            const d = idx + 1;
            const fullDate = `${year}-${month}-${String(d).padStart(2, "0")}`;
            return <DayCell key={fullDate} fullDate={fullDate} day={d} record={attendanceMap.get(fullDate)} active={isActiveDate(fullDate)} isOverflow={false} />;
        });

        // trailing overflow cells (next month start)
        const totalSoFar = firstDOW + daysInMon;
        const trailingCount = (7 - totalSoFar % 7) % 7;
        const nextMo = (parseInt(month) % 12 + 1).toString().padStart(2, "0");
        const nextYr = month === "12" ? (parseInt(year) + 1).toString() : year;
        // const overflowTrailing = Array.from({ length: trailingCount }, (_, i) => (
        //     <DayCell key={`ov-t-${i}`} fullDate={`${nextYr}-${nextMo}-${String(i + 1).padStart(2, "0")}`} day={i + 1} record={null} active={false} isOverflow={true} />
        // ));

        const overflowTrailing = Array.from({ length: trailingCount }, (_, i) => (
            <td key={`ov-t-${i}`} style={{ padding: "1px", height: "54px", width: "14.28%" }} />
        ));

        const allCells = [...overflowLeading, ...dayCells, ...overflowTrailing];
        const rows = [];
        for (let i = 0; i < allCells.length; i += 7) rows.push(<tr key={i}>{allCells.slice(i, i + 7)}</tr>);

        return (
            <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                <tbody>
                    <tr>{headers}</tr>
                    {rows}
                </tbody>
            </table>
        );
    };

    // ── Stat card ──────────────────────────────────────────────────────────────
    const StatCard = ({ icon, label, value, iconBg, isPercent, bgColor }) => (
        <div className="emp-stats" style={{
            background: bgColor,
        }}>
            <div style={{ width: 36, height: 36, borderRadius: "50%", background: iconBg, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 17 }}>
                {icon}
            </div>
            <div>
                <div style={{ fontSize: "10px", color: "#94A3B8", fontWeight: 400, marginBottom: 2 }}>{label}</div>
                <div style={{ fontSize: "20px", fontWeight: 700, color: "#1e293b", lineHeight: 1 }}>
                    {value}{isPercent && "%"}
                    {isPercent && <span style={{ fontSize: "9px", color: "#94A3B8", marginLeft: 3 }}>This Month</span>}
                </div>
            </div>
        </div>
    );

    // ── Today panel ────────────────────────────────────────────────────────────
    const TodayPanel = () => {
        const status = todayRecord
            ? (DAY_STATUS_FULL[todayRecord.day_status] ?? todayRecord.day_status)
            : "Present";

        const statusStyle = todayRecord
            ? STATUS_BADGE[todayRecord.day_status]
            : STATUS_BADGE.ontime;

        const checkIn = todayRecord?.in_time && todayRecord.in_time !== "-" ? todayRecord.in_time : "--:--";
        const checkOut = todayRecord?.out_time && todayRecord.out_time !== "-" ? todayRecord.out_time : "-- : --";

        return (
            <div
                className="todays-calender"
            >
                <div className="tdc-wrapper" style={{ display: "none" }}></div>
                <div className="tdc-mobile-row">
                    <div className="tdc-date-status">
                        <div className="tdc-mobile-today">
                            <div className="tdc-title">Today</div>
                            <div className="tdc-date">{todayDateNum} {todayMonthLong} {currentYear}</div>
                        </div>

                        <div className="tdc-status-badge"
                            style={{
                                background: statusStyle?.bg || "#F0FDF4",
                                color: statusStyle?.text || "#166534",
                            }}>
                            <span
                                className="tdc-status-dot"
                                style={{ background: statusStyle?.dot || "#22C55E" }}
                            />
                            {status}
                        </div>
                    </div>
                    <div className="tdc-checkin-row">
                        <div className="tdc-entry">
                            <div className="tdc-icon" style={{ color: "#22C55E" }}>
                                <ClockIcon />
                            </div>
                            <div>
                                <div className="tdc-label">Check-in</div>
                                <div className="tdc-value">{checkIn}</div>
                            </div>
                        </div>
                        <div className="tdc-entry">
                            <div className="tdc-icon" style={{ color: "#3B82F6" }}>
                                <ClockIcon />
                            </div>
                            <div>
                                <div className="tdc-label">Check-out</div>
                                <div className="tdc-value">{checkOut}</div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div style={{ marginTop: "auto", fontSize: 12, color: "#3B82F6", fontWeight: 500, cursor: "pointer", display: "flex", alignItems: "center", gap: 4 }}>
                    View My Timeline →
                </div> */}
            </div>
        );
    };

    // ── Render ─────────────────────────────────────────────────────────────────
    const LEGEND = [
        { dot: "#22C55E", label: "Present" },
        { dot: "#EF4444", label: "Absent" },
        { dot: "#F97316", label: "Late" },
        { dot: "#588de2", label: "RLM" },
        { dot: "#2563EB", label: "Out Duty" },
        { dot: "#075e41", label: "Paid Leave" },
        { dot: "#b906b9", label: "Short Leave" },
        { dot: "#F59E0B", label: "Half Day" },
        { dot: "#5112e4", label: "Holiday / Leave" },
        { dot: "#94A3B8", label: "Weekly Off" },
        { dot: null, label: "Start Day of month", startDay: true },
        { dot: null, label: "Outside Payroll Cycle", stripe: true },
    ];

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false}
                newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <div style={{ background: "#ffffff", borderRadius: 14, padding: 20, display: "flex", flexDirection: "column", gap: 12, flex: 1, width: customWidth }}>

                {/* ── Top bar ── */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <div style={{ width: 34, height: 34, borderRadius: 8, background: "#e3f0ff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16 }}><Calender color="rgb(37, 118, 188)" strokeColor="rgb(37, 118, 188)" /></div>
                        <span style={{ fontWeight: 700, fontSize: 15, color: "#1e293b" }}>Calendar</span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        {isLoading ? <div className="spinner-small" /> : (
                            <select
                                onChange={handleChange}
                                value={selectedMonthYear}
                                style={{ border: "1px solid #E2E8F0", borderRadius: 8, padding: "5px 10px", fontSize: 12, fontWeight: 500, color: "#334155", background: "#fff", cursor: "pointer", outline: "none" }}
                            >
                                {monthYearOptions.map(o => (
                                    <option key={o.value} value={o.value}>{o.label}</option>
                                ))}
                            </select>
                        )}
                    </div>
                </div>

                {/* ── Stat cards ── */}
                <div className="dashboard-attendance-stats new-dashbaord-attendance-stats" >
                    <StatCard icon={<UserProfileIcon />} label="Present" value={stats.present} bgColor="rgb(241 253 244)" />
                    <StatCard icon={<UserProfileIcon color="#EF4444" />} label="Absent" value={stats.absent} bgColor="rgb(253 242 242)" />
                    <StatCard icon={<UserProfileIcon color="#f8dc3b" />} label="Leave" value={stats.leave} bgColor="rgb(255 252 229)" />
                    <StatCard icon={<Calender />} label="Weekly Off" value={stats.wo} bgColor="rgb(239 246 255)" />
                    {/* <StatCard icon="📊" label="Attendance" value={stats.att} iconBg="#EFF6FF" isPercent /> */}
                </div>

                {/* ── Calendar card: prev | curr | today ── */}
                {/* <div className="calender-container">
                    <div className="display-calender-container">
                        <div
                            className="display-calendar-panel"

                        // style={{ flex: "0 0 auto", width: "40%", background: "#F8FAFC", padding: "12px 8px 8px 12px", borderRight: "1px solid #EEF2F6" }}
                        >
                            <div
                                style={{
                                    fontSize: "17px",
                                    fontWeight: 600,
                                    color: "#6B7280",
                                    marginBottom: "8px",
                                }}
                            // style={{ fontSize: 13, fontWeight: 600, color: "#64748B", marginBottom: 8 }}
                            >
                                {getMonthName(parseInt(prevMonthStr))} {prevYear}
                            </div>
                            {renderMonthTable(prevYear, prevMonthStr, patchedPrevMap, prevBuffer)}
                        </div>

                        <div
                            className="current-calendar-panel"

                        // style={{ flex: "0 0 auto", width: "40%", borderLeft: "3px solid #3B82F6", padding: "12px 8px 8px 14px" }}
                        >

                            <div
                                // style={{ fontSize: 15, fontWeight: 700, color: "#3B82F6", marginBottom: 8 }}
                                style={{
                                    fontSize: "18px",
                                    fontWeight: 700,
                                    color: "#2563EB",
                                    marginBottom: "8px",
                                    marginTop: "4px",
                                }}
                            >
                                {getMonthName(parseInt(selectedMonth))} {selectedYear}
                            </div>
                            {renderMonthTable(selectedYear, selectedMonth, currMap, currBuffer)}
                        </div>
                    </div>

                    <TodayPanel />
                </div> */}

                {/* ── Calendar card: prev | curr | today ── */}
                <div className="calender-container">
                    <div className="display-calender-container w-full">
                        {(currBuffer || prevBuffer) ? (
                            // ── Single unified loader while either fetch is in flight ──
                            <div style={{
                                width: "100%",
                                minHeight: "280px",
                                height: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}>
                                <Loader container={true} />
                            </div>
                        ) : (
                            <>
                                {/* LEFT — prev month (only once we know it's a multi-month cycle) */}
                                {!isSingleMonthCycle && (
                                    <div className="display-calendar-panel">
                                        <div style={{
                                            fontSize: "17px",
                                            fontWeight: 600,
                                            color: "#6B7280",
                                            marginBottom: "8px",
                                        }}>
                                            {getMonthName(parseInt(prevMonthStr))} {prevYear}
                                        </div>
                                        {renderMonthTable(prevYear, prevMonthStr, patchedPrevMap, false)}
                                    </div>
                                )}

                                {/* MIDDLE — curr month (always rendered) */}
                                <div className="current-calendar-panel" style={{ width: "auto" }}>
                                    <div style={{
                                        fontSize: "18px",
                                        fontWeight: 700,
                                        color: "#2563EB",
                                        marginBottom: "8px",
                                        marginTop: "4px",
                                    }}>
                                        {getMonthName(parseInt(selectedMonth))} {selectedYear}
                                    </div>
                                    {renderMonthTable(selectedYear, selectedMonth, currMap, false)}
                                </div>
                            </>
                        )}
                    </div>

                    {/* RIGHT — Today panel */}
                    <TodayPanel />
                </div>

                {/* ── Legend ── */}
                <div style={{ display: "flex", flexWrap: "wrap", gap: "7px 20px", paddingTop: 10 }}>
                    {/* {LEGEND.map(({ dot, label, stripe }) => (
                        <div key={label} style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 11, color: "#64748B" }}>
                            {stripe
                                ? <div style={{ width: 13, height: 12, borderRadius: 3, background: "repeating-linear-gradient(135deg,#e2e8f0,#e2e8f0 2px,#f8fafc 2px,#f8fafc 5px)", border: "1px solid #CBD5E1", flexShrink: 0 }} />
                                : <span style={{ width: 9, height: 9, borderRadius: "50%", background: dot, display: "inline-block", flexShrink: 0 }} />
                            }
                            {label}
                        </div>
                    ))} */}

                    {LEGEND.map(({ dot, label, stripe, startDay }) => (
                        <div key={label} style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 11, color: "#64748B" }}>
                            {stripe
                                ? <div style={{ width: 13, height: 12, borderRadius: 3, background: "repeating-linear-gradient(135deg,#e2e8f0,#e2e8f0 2px,#f8fafc 2px,#f8fafc 5px)", border: "1px solid #CBD5E1", flexShrink: 0 }} />
                                : startDay
                                    ? <div style={{ width: 16, height: 16, borderRadius: "5px", background: "#EBF4FF", border: "1.5px solid #2563EB", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 9, fontWeight: 600, color: "#2563EB" }}>1</div>
                                    : <span style={{ width: 9, height: 9, borderRadius: "50%", background: dot, display: "inline-block", flexShrink: 0 }} />
                            }
                            {label}
                        </div>
                    ))}
                </div>
            </div>


        </>
    );
}


export default Calaneder;
